/*
 * # Semantic - Modal
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Copyright 2013 Contributors
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */

;(function ( $, window, document, undefined ) {

    $.fn.modal = function(parameters) {
        var
        $allModules = $(this),
        $window     = $(window),
        $document   = $(document),
        $body       = $('body'),

        time            = new Date().getTime(),
        performance     = [],

        query           = arguments[0],
        methodInvoked   = (typeof query == 'string'),
        queryArguments  = [].slice.call(arguments, 1),

        requestAnimationFrame = window.requestAnimationFrame
        || window.mozRequestAnimationFrame
        || window.webkitRequestAnimationFrame
        || window.msRequestAnimationFrame
        || function(callback) { setTimeout(callback, 0); },

        returnedValue
        ;


        $allModules
        .each(function() {
            var
            settings    = ( $.isPlainObject(parameters) )
            ? $.extend(true, {}, $.fn.modal.settings, parameters)
            : $.extend({}, $.fn.modal.settings),

            selector        = settings.selector,
            className       = settings.className,
            namespace       = settings.namespace,
            error           = settings.error,

            eventNamespace  = '.' + namespace,
            moduleNamespace = 'module-' + namespace,
            moduleSelector  = $allModules.selector || '',

            $module      = $(this),
            $context     = $(settings.context),
            $close       = $module.find(selector.close),

            $allModals,
            $otherModals,
            $focusedElement,
            $dimmable,
            $dimmer,

            element      = this,
            instance     = $module.data(moduleNamespace),
            module
            ;

            module  = {

                initialize: function() {
                    module.verbose('Initializing dimmer', $context);

                    if($.fn.dimmer === undefined) {
                        module.error(error.dimmer);
                        return;
                    }
                    $dimmable = $context
                    .dimmer({
                        closable : false,
                        useCSS   : true,
                        duration : {
                            show     : settings.duration * 0.9,
                            hide     : settings.duration * 1.1
                        }
                    })
                    ;

                    if(settings.detachable) {
                        $dimmable.dimmer('add content', $module);
                    }

                    $dimmer = $dimmable
                    .dimmer('get dimmer')
                    ;

                    module.refreshSelectors();

                    module.verbose('Attaching close events', $close);
                    $close
                    .on('click' + eventNamespace, module.event.close)
                    ;
                    $window
                    .on('resize' + eventNamespace, module.event.resize)
                    ;
                    module.instantiate();
                },

                instantiate: function() {
                    module.verbose('Storing instance of modal');
                    instance = module;
                    $module
                    .data(moduleNamespace, instance)
                    ;
                },

                destroy: function() {
                    module.verbose('Destroying previous modal');
                    $module
                    .removeData(moduleNamespace)
                    .off(eventNamespace)
                    ;
                    $close
                    .off(eventNamespace)
                    ;
                    $context
                    .dimmer('destroy')
                    ;
                },

                refresh: function() {
                    module.remove.scrolling();
                    module.cacheSizes();
                    module.set.screenHeight();
                    module.set.type();
                    module.set.position();
                },

                refreshSelectors: function() {
                    $otherModals = $module.siblings(selector.modal);
                    $allModals   = $otherModals.add($module);
                },

                attachEvents: function(selector, event) {
                    var
                    $toggle = $(selector)
                    ;
                    event = $.isFunction(module[event])
                    ? module[event]
                    : module.toggle
                    ;
                    if($toggle.size() > 0) {
                        module.debug('Attaching modal events to element', selector, event);
                        $toggle
                        .off(eventNamespace)
                        .on('click' + eventNamespace, event)
                        ;
                    }
                    else {
                        module.error(error.notFound);
                    }
                },

                event: {
                    close: function() {
                        module.verbose('Closing element pressed');
                        if( $(this).is(selector.approve) ) {
                            if($.proxy(settings.onApprove, element)() !== false) {
                                module.hide();
                            }
                            else {
                                module.verbose('Approve callback returned false cancelling hide');
                            }
                        }
                        else if( $(this).is(selector.deny) ) {
                            if($.proxy(settings.onDeny, element)() !== false) {
                                module.hide();
                            }
                            else {
                                module.verbose('Deny callback returned false cancelling hide');
                            }
                        }
                        else {
                            module.hide();
                        }
                    },
                    click: function(event) {
                        if( $(event.target).closest(selector.modal).size() === 0 ) {
                            module.debug('Dimmer clicked, hiding all modals');
                            if(settings.allowMultiple) {
                                module.hide();
                            }
                            else {
                                module.hideAll();
                            }
                            event.stopImmediatePropagation();
                        }
                    },
                    debounce: function(method, delay) {
                        clearTimeout(module.timer);
                        module.timer = setTimeout(method, delay);
                    },
                    keyboard: function(event) {
                        var
                        keyCode   = event.which,
                        escapeKey = 27
                        ;
                        if(keyCode == escapeKey) {
                            if(settings.closable) {
                                module.debug('Escape key pressed hiding modal');
                                module.hide();
                            }
                            else {
                                module.debug('Escape key pressed, but closable is set to false');
                            }
                            event.preventDefault();
                        }
                    },
                    resize: function() {
                        if( $dimmable.dimmer('is active') ) {
                            requestAnimationFrame(module.refresh);
                        }
                    }
                },

                toggle: function() {
                    if( module.is.active() ) {
                        module.hide();
                    }
                    else {
                        module.show();
                    }
                },

                show: function(callback) {
                    callback = $.isFunction(callback)
                    ? callback
                    : function(){}
                    ;
                    module.showDimmer();
                    module.showModal(callback);
                },

                onlyVisible: function() {
                    module.refreshSelectors();
                    return module.is.active() && $otherModals.filter(':visible').size() === 0;
                },

                othersVisible: function() {
                    module.refreshSelectors();
                    return $otherModals.filter(':visible').size() > 0;
                },

                showModal: function(callback) {
                    if(module.is.active()) {
                        module.debug('Modal is already visible');
                        return;
                    }

                    callback = $.isFunction(callback)
                    ? callback
                    : function(){}
                    ;

                    module.save.focus();
                    module.add.keyboardShortcuts();

                    if(module.cache === undefined) {
                        module.cacheSizes();
                    }
                    module.set.scrollTop();
                    module.set.position();
                    module.set.screenHeight();
                    module.set.type();

                    if(module.othersVisible()  && !settings.allowMultiple) {
                        module.debug('Other modals visible, queueing show animation');
                        module.hideOthers(module.showModal);
                    }
                    else {
                        $.proxy(settings.onShow, element)();

                        var transitionCallback = function() {
                            module.set.active();
                            $.proxy(settings.onVisible, element)();
                            callback();
                        };

                        if(settings.transition && $.fn.transition !== undefined && $module.transition('is supported')) {
                            module.debug('Showing modal with css animations');
                            $module
                            .transition(settings.transition + ' in', settings.duration, transitionCallback)
                            ;
                        }
                        else {
                            module.debug('Showing modal with javascript');
                            $module
                            .fadeIn(settings.duration, settings.easing, transitionCallback)
                            ;
                        }
                    }
                },

                showDimmer: function() {
                    if( !$dimmable.dimmer('is active') ) {
                        module.debug('Showing dimmer');
                        $dimmable.dimmer('show');
                    }
                    else {
                        module.debug('Dimmer is already visible');
                    }
                },

                hide: function(callback) {
                    callback = $.isFunction(callback)
                    ? callback
                    : function(){}
                    ;
                    module.refreshSelectors();
                    if(module.onlyVisible()) {
                        module.hideDimmer();
                    }
                    module.hideModal(callback);
                    window.scrollTo(null, module.cache.scroll);
                },

                hideDimmer: function() {
                    if( !module.is.active() ) {
                        module.debug('Dimmer is already hidden');
                        return;
                    }
                    module.debug('Hiding dimmer');
                    if(settings.closable) {
                        $dimmer
                        .off('click' + eventNamespace)
                        ;
                    }
                    $dimmable.dimmer('hide', function() {
                        if(settings.transition && $.fn.transition !== undefined && $module.transition('is supported')) {
                            $module
                            .transition('reset')
                            ;
                            module.remove.screenHeight();
                        }
                        module.remove.active();
                    });
                },

                hideModal: function(callback) {
                    if(!module.is.active()) {
                        module.debug('Modal is already hidden');
                        return;
                    }

                    callback = $.isFunction(callback)
                    ? callback
                    : function(){}
                    ;

                    module.restore.focus();
                    module.remove.keyboardShortcuts();

                    $.proxy(settings.onHide, element)();

                    var transitionCallback = function() {
                        module.remove.active();
                        $.proxy(settings.onHidden, element)();
                        callback();
                    };

                    if(settings.transition && $.fn.transition !== undefined && $module.transition('is supported')) {
                        module.debug('Hiding modal with css animations');
                        $module
                        .transition(settings.transition + ' out', settings.duration, transitionCallback)
                        ;
                    }
                    else {
                        module.debug('Hiding modal with javascript');
                        $module
                        .fadeOut(settings.duration, settings.easing, transitionCallback)
                        ;
                    }
                },

                hideAll: function(callback) {
                    callback = $.isFunction(callback)
                    ? callback
                    : function(){}
                    ;
                    if( $module.is(':visible') || module.othersVisible() ) {
                        module.debug('Hiding all visible modals');
                        module.hideDimmer();
                        $allModals
                        .filter(':visible')
                        .modal('hide modal', callback)
                        ;
                    }
                },

                hideOthers: function(callback) {
                    callback = $.isFunction(callback)
                    ? callback
                    : function(){}
                    ;
                    if( module.othersVisible() ) {
                        module.debug('Hiding other modals');
                        $otherModals
                        .filter(':visible')
                        .modal('hide modal', callback)
                        ;
                    }
                },

                add: {
                    keyboardShortcuts: function() {
                        module.verbose('Adding keyboard shortcuts');
                        $document
                        .on('keyup' + eventNamespace, module.event.keyboard)
                        ;
                    }
                },

                save: {
                    focus: function() {
                        $focusedElement = $(document.activeElement).blur();
                    }
                },

                restore: {
                    focus: function() {
                        if($focusedElement && $focusedElement.size() > 0) {
                            $focusedElement.focus();
                        }
                    }
                },

                remove: {
                    active: function() {
                        $module.removeClass(className.active);
                    },
                    screenHeight: function() {
                        if(module.cache.height > module.cache.pageHeight) {
                            module.debug('Removing page height');
                            $body
                            .css('height', '')
                            ;
                        }
                    },
                    keyboardShortcuts: function() {
                        module.verbose('Removing keyboard shortcuts');
                        $document
                        .off('keyup' + eventNamespace)
                        ;
                    },
                    scrolling: function() {
                        $dimmable.removeClass(className.scrolling);
                        $module.removeClass(className.scrolling);
                    }
                },

                cacheSizes: function() {
                    module.cache = {
                        scroll        : window.scrollY,
                        pageHeight    : $body.outerHeight(),
                        height        : $module.outerHeight() + settings.offset,
                        contextHeight : (settings.context == 'body')
                        ? $(window).height()
                        : $dimmable.height()
                    };
                    module.debug('Caching modal and container sizes', module.cache);
                },

                can: {
                    fit: function() {
                        return (module.cache.height < module.cache.contextHeight);
                    }
                },

                is: {
                    active: function() {
                        return $module.hasClass(className.active);
                    },
                    modernBrowser: function() {
                        // appName for IE11 reports 'Netscape' can no longer use
                        return !(window.ActiveXObject || "ActiveXObject" in window);
                    }
                },

                set: {
                    // scrool page to top before modal opens
                    scrollTop: function(){
                        window.scrollTo(null, 0);

                    },
                    screenHeight: function() {
                        if(module.cache.height > module.cache.pageHeight) {
                            module.debug('Modal is taller than page content, resizing page height');
                            $body
                            .css('height', module.cache.height + settings.padding)
                            ;
                        }
                    },
                    active: function() {
                        $module.addClass(className.active);

                        if(settings.closable) {
                            $dimmer
                            .off('click' + eventNamespace)
                            .on('click' + eventNamespace, module.event.click)
                            ;
                        }

                        if(settings.autofocus) {
                            var $inputs    = $module.find(':input:visible');
                            var $autofocus = $inputs.filter('[autofocus]');
                            var $input     = $autofocus.length ? $autofocus : $inputs;

                            $input.first().focus();
                        }
                    },
                    scrolling: function() {
                        $dimmable.addClass(className.scrolling);
                        $module.addClass(className.scrolling);
                    },
                    type: function() {
                        if(module.can.fit()) {
                            module.verbose('Modal fits on screen');
                            module.remove.scrolling();
                        }
                        else {
                            module.verbose('Modal cannot fit on screen setting to scrolling');
                            module.set.scrolling();
                        }
                    },
                    position: function() {
                        module.verbose('Centering modal on page', module.cache);
                        $module
                        .css({
                            marginTop : '1em',
                            top       : 0 
                        })
                        ;
                        /*
                        if(module.can.fit()) {
                            $module
                            .css({
                                top: '',
                                marginTop: -(module.cache.height / 2)
                            })
                            ;
                        }
                        else {
                            $module
                            .css({
                                marginTop : '1em',
                                top       : $document.scrollTop()
                            })
                            ;
                        }
                        */
                    }
                },

                setting: function(name, value) {
                    module.debug('Changing setting', name, value);
                    if( $.isPlainObject(name) ) {
                        $.extend(true, settings, name);
                    }
                    else if(value !== undefined) {
                        settings[name] = value;
                    }
                    else {
                        return settings[name];
                    }
                },
                internal: function(name, value) {
                    if( $.isPlainObject(name) ) {
                        $.extend(true, module, name);
                    }
                    else if(value !== undefined) {
                        module[name] = value;
                    }
                    else {
                        return module[name];
                    }
                },
                debug: function() {
                    if(settings.debug) {
                        if(settings.performance) {
                            module.performance.log(arguments);
                        }
                        else {
                            module.debug = Function.prototype.bind.call(console.info, console, settings.name + ':');
                            module.debug.apply(console, arguments);
                        }
                    }
                },
                verbose: function() {
                    if(settings.verbose && settings.debug) {
                        if(settings.performance) {
                            module.performance.log(arguments);
                        }
                        else {
                            module.verbose = Function.prototype.bind.call(console.info, console, settings.name + ':');
                            module.verbose.apply(console, arguments);
                        }
                    }
                },
                error: function() {
                    module.error = Function.prototype.bind.call(console.error, console, settings.name + ':');
                    module.error.apply(console, arguments);
                },
                performance: {
                    log: function(message) {
                        var
                        currentTime,
                        executionTime,
                        previousTime
                        ;
                        if(settings.performance) {
                            currentTime   = new Date().getTime();
                            previousTime  = time || currentTime;
                            executionTime = currentTime - previousTime;
                            time          = currentTime;
                            performance.push({
                                'Element'        : element,
                                'Name'           : message[0],
                                'Arguments'      : [].slice.call(message, 1) || '',
                                'Execution Time' : executionTime
                            });
                        }
                        clearTimeout(module.performance.timer);
                        module.performance.timer = setTimeout(module.performance.display, 100);
                    },
                    display: function() {
                        var
                        title = settings.name + ':',
                        totalTime = 0
                        ;
                        time = false;
                        clearTimeout(module.performance.timer);
                        $.each(performance, function(index, data) {
                            totalTime += data['Execution Time'];
                        });
                        title += ' ' + totalTime + 'ms';
                        if(moduleSelector) {
                            title += ' \'' + moduleSelector + '\'';
                        }
                        if( (console.group !== undefined || console.table !== undefined) && performance.length > 0) {
                            console.groupCollapsed(title);
                            if(console.table) {
                                console.table(performance);
                            }
                            else {
                                $.each(performance, function(index, data) {
                                    console.log(data['Name'] + ': ' + data['Execution Time']+'ms');
                                });
                            }
                            console.groupEnd();
                        }
                        performance = [];
                    }
                },
                invoke: function(query, passedArguments, context) {
                    var
                    object = instance,
                    maxDepth,
                    found,
                    response
                    ;
                    passedArguments = passedArguments || queryArguments;
                    context         = element         || context;
                    if(typeof query == 'string' && object !== undefined) {
                        query    = query.split(/[\. ]/);
                        maxDepth = query.length - 1;
                        $.each(query, function(depth, value) {
                            var camelCaseValue = (depth != maxDepth)
                            ? value + query[depth + 1].charAt(0).toUpperCase() + query[depth + 1].slice(1)
                            : query
                            ;
                            if( $.isPlainObject( object[camelCaseValue] ) && (depth != maxDepth) ) {
                                object = object[camelCaseValue];
                            }
                            else if( object[camelCaseValue] !== undefined ) {
                                found = object[camelCaseValue];
                                return false;
                            }
                            else if( $.isPlainObject( object[value] ) && (depth != maxDepth) ) {
                                object = object[value];
                            }
                            else if( object[value] !== undefined ) {
                                found = object[value];
                                return false;
                            }
                            else {
                                return false;
                            }
                        });
                    }
                    if ( $.isFunction( found ) ) {
                        response = found.apply(context, passedArguments);
                    }
                    else if(found !== undefined) {
                        response = found;
                    }
                    if($.isArray(returnedValue)) {
                        returnedValue.push(response);
                    }
                    else if(returnedValue !== undefined) {
                        returnedValue = [returnedValue, response];
                    }
                    else if(response !== undefined) {
                        returnedValue = response;
                    }
                    return found;
                }
            };

            if(methodInvoked) {
                if(instance === undefined) {
                    module.initialize();
                }
                module.invoke(query);
            }
            else {
                if(instance !== undefined) {
                    module.destroy();
                }
                module.initialize();
            }
        })
        ;

        return (returnedValue !== undefined)
        ? returnedValue
        : this
        ;
    };

    $.fn.modal.settings = {

        name          : 'Modal',
        namespace     : 'modal',

        debug         : false,
        verbose       : true,
        performance   : true,

        allowMultiple : true,
        detachable    : true,
        closable      : true,
        autofocus     : true,
        context       : 'body',

        duration      : 500,
        easing        : 'easeOutQuad',
        offset        : 0,
        transition    : 'scale',

        padding       : 30,

        onShow        : function(){},
        onHide        : function(){},

        onVisible     : function(){},
        onHidden      : function(){},

        onApprove     : function(){ return true; },
        onDeny        : function(){ return true; },

        selector    : {
            close    : '.close, .actions .button',
            approve  : '.actions .positive, .actions .approve, .actions .ok',
            deny     : '.actions .negative, .actions .deny, .actions .cancel',
            modal    : '.ui.modal'
        },
        error : {
            dimmer    : 'UI Dimmer, a required component is not included in this page',
            method    : 'The method you called is not defined.'
        },
        className : {
            active    : 'active',
            scrolling : 'scrolling'
        }
    };

    // Adds easing
    $.extend( $.easing, {
        easeOutQuad: function (x, t, b, c, d) {
            return -c *(t/=d)*(t-2) + b;
        }
    });

})( jQuery, window , document );


/*
 * # Semantic - Dimmer
 * http://github.com/jlukic/semantic-ui/
 *
 *
 * Copyright 2013 Contributors
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */

;(function ( $, window, document, undefined ) {

    $.fn.dimmer = function(parameters) {
        var
        $allModules     = $(this),

        time            = new Date().getTime(),
        performance     = [],

        query           = arguments[0],
        methodInvoked   = (typeof query == 'string'),
        queryArguments  = [].slice.call(arguments, 1),

        returnedValue
        ;

        $allModules
        .each(function() {
            var
            settings        = ( $.isPlainObject(parameters) )
            ? $.extend(true, {}, $.fn.dimmer.settings, parameters)
            : $.extend({}, $.fn.dimmer.settings),

            selector        = settings.selector,
            namespace       = settings.namespace,
            className       = settings.className,
            error           = settings.error,

            eventNamespace  = '.' + namespace,
            moduleNamespace = 'module-' + namespace,
            moduleSelector  = $allModules.selector || '',

            clickEvent      = ('ontouchstart' in document.documentElement)
            ? 'touchstart'
            : 'click',

            $module = $(this),
            $dimmer,
            $dimmable,

            element   = this,
            instance  = $module.data(moduleNamespace),
            module
            ;

            module = {

                preinitialize: function() {
                    if( module.is.dimmer() ) {
                        $dimmable = $module.parent();
                        $dimmer   = $module;
                    }
                    else {
                        $dimmable = $module;
                        if( module.has.dimmer() ) {
                            $dimmer = $dimmable.children(selector.dimmer).first();
                        }
                        else {
                            $dimmer = module.create();
                        }
                    }
                },

                initialize: function() {
                    module.debug('Initializing dimmer', settings);
                    if(settings.on == 'hover') {
                        $dimmable
                        .on('mouseenter' + eventNamespace, module.show)
                        .on('mouseleave' + eventNamespace, module.hide)
                        ;
                    }
                    else if(settings.on == 'click') {
                        $dimmable
                        .on(clickEvent + eventNamespace, module.toggle)
                        ;
                    }

                    if( module.is.page() ) {
                        module.debug('Setting as a page dimmer', $dimmable);
                        module.set.pageDimmer();
                    }

                    if(settings.closable) {
                        module.verbose('Adding dimmer close event', $dimmer);
                        $dimmer
                        .on(clickEvent + eventNamespace, module.event.click)
                        ;
                    }
                    module.set.dimmable();
                    module.instantiate();
                },

                instantiate: function() {
                    module.verbose('Storing instance of module', module);
                    instance = module;
                    $module
                    .data(moduleNamespace, instance)
                    ;
                },

                destroy: function() {
                    module.verbose('Destroying previous module', $dimmer);
                    $module
                    .removeData(moduleNamespace)
                    ;
                    $dimmable
                    .off(eventNamespace)
                    ;
                    $dimmer
                    .off(eventNamespace)
                    ;
                },

                event: {

                    click: function(event) {
                        module.verbose('Determining if event occured on dimmer', event);
                        if( $dimmer.find(event.target).size() === 0 || $(event.target).is(selector.content) ) {
                            module.hide();
                            event.stopImmediatePropagation();
                        }
                    }

                },

                addContent: function(element) {
                    var
                    $content = $(element)
                    ;
                    module.debug('Add content to dimmer', $content);
                    if($content.parent()[0] !== $dimmer[0]) {
                        $content.detach().appendTo($dimmer);
                    }
                },

                create: function() {
                    return $( settings.template.dimmer() ).appendTo($dimmable);
                },

                animate: {
                    show: function(callback) {
                        callback = $.isFunction(callback)
                        ? callback
                        : function(){}
                        ;
                        module.set.dimmed();
                        if(settings.on != 'hover' && settings.useCSS && $.fn.transition !== undefined && $dimmer.transition('is supported')) {
                            $dimmer
                            .transition({
                                animation : settings.transition + ' in',
                                queue     : true,
                                duration  : module.get.duration(),
                                complete  : function() {
                                    module.set.active();
                                    callback();
                                }
                            })
                            ;
                        }
                        else {
                            module.verbose('Showing dimmer animation with javascript');
                            $dimmer
                            .stop()
                            .css({
                                opacity : 0,
                                width   : '100%',
                                height  : '100%'
                            })
                            .fadeTo(module.get.duration(), 1, function() {
                                $dimmer.removeAttr('style');
                                module.set.active();
                                callback();
                            })
                            ;
                        }
                    },
                    hide: function(callback) {
                        callback = $.isFunction(callback)
                        ? callback
                        : function(){}
                        ;
                        if(settings.on != 'hover' && settings.useCSS && $.fn.transition !== undefined && $dimmer.transition('is supported')) {
                            module.verbose('Hiding dimmer with css');
                            $dimmer
                            .transition({
                                animation : settings.transition + ' out',
                                duration  : module.get.duration(),
                                queue     : true,
                                complete  : function() {
                                    module.remove.dimmed();
                                    module.remove.active();
                                    callback();
                                }
                            })
                            ;
                        }
                        else {
                            module.verbose('Hiding dimmer with javascript');
                            $dimmer
                            .stop()
                            .fadeOut(module.get.duration(), function() {
                                $dimmer.removeAttr('style');
                                module.remove.dimmed();
                                module.remove.active();
                                callback();
                            })
                            ;
                        }
                    }
                },

                get: {
                    dimmer: function() {
                        return $dimmer;
                    },
                    duration: function() {
                        if(typeof settings.duration == 'object') {
                            if( module.is.active() ) {
                                return settings.duration.hide;
                            }
                            else {
                                return settings.duration.show;
                            }
                        }
                        return settings.duration;
                    }
                },

                has: {
                    dimmer: function() {
                        return ( $module.children(selector.dimmer).size() > 0 );
                    }
                },

                is: {
                    active: function() {
                        return $dimmer.hasClass(className.active);
                    },
                    animating: function() {
                        return ( $dimmer.is(':animated') || $dimmer.hasClass(className.transition) );
                    },
                    dimmer: function() {
                        return $module.is(selector.dimmer);
                    },
                    dimmable: function() {
                        return $module.is(selector.dimmable);
                    },
                    dimmed: function() {
                        return $dimmable.hasClass(className.dimmed);
                    },
                    disabled: function() {
                        return $dimmable.hasClass(className.disabled);
                    },
                    enabled: function() {
                        return !module.is.disabled();
                    },
                    page: function () {
                        return $dimmable.is('body');
                    },
                    pageDimmer: function() {
                        return $dimmer.hasClass(className.pageDimmer);
                    }
                },

                can: {
                    show: function() {
                        return !$dimmer.hasClass(className.disabled);
                    }
                },

                set: {
                    active: function() {
                        module.set.dimmed();
                        $dimmer
                        .removeClass(className.transition)
                        .addClass(className.active)
                        ;
                    },
                    dimmable: function() {
                        $dimmable.addClass(className.dimmable);
                    },
                    dimmed: function() {
                        $dimmable.addClass(className.dimmed);
                    },
                    pageDimmer: function() {
                        $dimmer.addClass(className.pageDimmer);
                    },
                    disabled: function() {
                        $dimmer.addClass(className.disabled);
                    }
                },

                remove: {
                    active: function() {
                        $dimmer
                        .removeClass(className.transition)
                        .removeClass(className.active)
                        ;
                    },
                    dimmed: function() {
                        $dimmable.removeClass(className.dimmed);
                    },
                    disabled: function() {
                        $dimmer.removeClass(className.disabled);
                    }
                },

                show: function(callback) {
                    callback = $.isFunction(callback)
                    ? callback
                    : function(){}
                    ;
                    module.debug('Showing dimmer', $dimmer, settings);
                    if( !module.is.active() && module.is.enabled() ) {
                        module.animate.show(callback);
                        $.proxy(settings.onShow, element)();
                        $.proxy(settings.onChange, element)();
                    }
                    else {
                        module.debug('Dimmer is already shown or disabled');
                    }
                },

                hide: function(callback) {
                    callback = $.isFunction(callback)
                    ? callback
                    : function(){}
                    ;
                    if( module.is.active() || module.is.animating() ) {
                        module.debug('Hiding dimmer', $dimmer);
                        module.animate.hide(callback);
                        $.proxy(settings.onHide, element)();
                        $.proxy(settings.onChange, element)();
                    }
                    else {
                        module.debug('Dimmer is not visible');
                    }
                },

                toggle: function() {
                    module.verbose('Toggling dimmer visibility', $dimmer);
                    if( !module.is.dimmed() ) {
                        module.show();
                    }
                    else {
                        module.hide();
                    }
                },

                setting: function(name, value) {
                    if( $.isPlainObject(name) ) {
                        $.extend(true, settings, name);
                    }
                    else if(value !== undefined) {
                        settings[name] = value;
                    }
                    else {
                        return settings[name];
                    }
                },
                internal: function(name, value) {
                    if( $.isPlainObject(name) ) {
                        $.extend(true, module, name);
                    }
                    else if(value !== undefined) {
                        module[name] = value;
                    }
                    else {
                        return module[name];
                    }
                },
                debug: function() {
                    if(settings.debug) {
                        if(settings.performance) {
                            module.performance.log(arguments);
                        }
                        else {
                            module.debug = Function.prototype.bind.call(console.info, console, settings.name + ':');
                            module.debug.apply(console, arguments);
                        }
                    }
                },
                verbose: function() {
                    if(settings.verbose && settings.debug) {
                        if(settings.performance) {
                            module.performance.log(arguments);
                        }
                        else {
                            module.verbose = Function.prototype.bind.call(console.info, console, settings.name + ':');
                            module.verbose.apply(console, arguments);
                        }
                    }
                },
                error: function() {
                    module.error = Function.prototype.bind.call(console.error, console, settings.name + ':');
                    module.error.apply(console, arguments);
                },
                performance: {
                    log: function(message) {
                        var
                        currentTime,
                        executionTime,
                        previousTime
                        ;
                        if(settings.performance) {
                            currentTime   = new Date().getTime();
                            previousTime  = time || currentTime;
                            executionTime = currentTime - previousTime;
                            time          = currentTime;
                            performance.push({
                                'Element'        : element,
                                'Name'           : message[0],
                                'Arguments'      : [].slice.call(message, 1) || '',
                                'Execution Time' : executionTime
                            });
                        }
                        clearTimeout(module.performance.timer);
                        module.performance.timer = setTimeout(module.performance.display, 100);
                    },
                    display: function() {
                        var
                        title = settings.name + ':',
                        totalTime = 0
                        ;
                        time = false;
                        clearTimeout(module.performance.timer);
                        $.each(performance, function(index, data) {
                            totalTime += data['Execution Time'];
                        });
                        title += ' ' + totalTime + 'ms';
                        if(moduleSelector) {
                            title += ' \'' + moduleSelector + '\'';
                        }
                        if($allModules.size() > 1) {
                            title += ' ' + '(' + $allModules.size() + ')';
                        }
                        if( (console.group !== undefined || console.table !== undefined) && performance.length > 0) {
                            console.groupCollapsed(title);
                            if(console.table) {
                                console.table(performance);
                            }
                            else {
                                $.each(performance, function(index, data) {
                                    console.log(data['Name'] + ': ' + data['Execution Time']+'ms');
                                });
                            }
                            console.groupEnd();
                        }
                        performance = [];
                    }
                },
                invoke: function(query, passedArguments, context) {
                    var
                    object = instance,
                    maxDepth,
                    found,
                    response
                    ;
                    passedArguments = passedArguments || queryArguments;
                    context         = element         || context;
                    if(typeof query == 'string' && object !== undefined) {
                        query    = query.split(/[\. ]/);
                        maxDepth = query.length - 1;
                        $.each(query, function(depth, value) {
                            var camelCaseValue = (depth != maxDepth)
                            ? value + query[depth + 1].charAt(0).toUpperCase() + query[depth + 1].slice(1)
                            : query
                            ;
                            if( $.isPlainObject( object[camelCaseValue] ) && (depth != maxDepth) ) {
                                object = object[camelCaseValue];
                            }
                            else if( object[camelCaseValue] !== undefined ) {
                                found = object[camelCaseValue];
                                return false;
                            }
                            else if( $.isPlainObject( object[value] ) && (depth != maxDepth) ) {
                                object = object[value];
                            }
                            else if( object[value] !== undefined ) {
                                found = object[value];
                                return false;
                            }
                            else {
                                return false;
                            }
                        });
                    }
                    if ( $.isFunction( found ) ) {
                        response = found.apply(context, passedArguments);
                    }
                    else if(found !== undefined) {
                        response = found;
                    }
                    if($.isArray(returnedValue)) {
                        returnedValue.push(response);
                    }
                    else if(returnedValue !== undefined) {
                        returnedValue = [returnedValue, response];
                    }
                    else if(response !== undefined) {
                        returnedValue = response;
                    }
                    return found;
                }
            };

            module.preinitialize();

            if(methodInvoked) {
                if(instance === undefined) {
                    module.initialize();
                }
                module.invoke(query);
            }
            else {
                if(instance !== undefined) {
                    module.destroy();
                }
                module.initialize();
            }
        })
        ;

        return (returnedValue !== undefined)
        ? returnedValue
        : this
        ;
    };

    $.fn.dimmer.settings = {

        name        : 'Dimmer',
        namespace   : 'dimmer',

        debug       : false,
        verbose     : true,
        performance : true,

        transition  : 'fade',
        useCSS      : true,
        on          : false,
        closable    : true,

        duration    : {
            show : 500,
            hide : 500
        },

        onChange    : function(){},
        onShow      : function(){},
        onHide      : function(){},

        error   : {
            method   : 'The method you called is not defined.'
        },

        selector: {
            dimmable : '.ui.dimmable',
            dimmer   : '.ui.dimmer',
            content  : '.ui.dimmer > .content, .ui.dimmer > .content > .center'
        },

        template: {
            dimmer: function() {
                return $('<div />').attr('class', 'ui dimmer');
            }
        },

        className : {
            active     : 'active',
            dimmable   : 'ui dimmable',
            dimmed     : 'dimmed',
            disabled   : 'disabled',
            pageDimmer : 'page',
            hide       : 'hide',
            show       : 'show',
            transition : 'transition'
        }

    };

})( jQuery, window , document );


/*
 * # Semantic - Transition
 * http://github.com/jlukic/semantic-ui/
 *
 *
 * Copyright 2013 Contributors
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */

;(function ( $, window, document, undefined ) {

    $.fn.transition = function() {
        var
        $allModules     = $(this),
        moduleSelector  = $allModules.selector || '',

        time            = new Date().getTime(),
        performance     = [],

        moduleArguments = arguments,
        query           = moduleArguments[0],
        queryArguments  = [].slice.call(arguments, 1),
        methodInvoked   = (typeof query === 'string'),

        requestAnimationFrame = window.requestAnimationFrame
        || window.mozRequestAnimationFrame
        || window.webkitRequestAnimationFrame
        || window.msRequestAnimationFrame
        || function(callback) { setTimeout(callback, 0); },

        returnedValue
        ;
        $allModules
        .each(function() {
            var
            $module  = $(this),
            element  = this,

            // set at run time
            settings,
            instance,

            error,
            className,
            metadata,
            animationEnd,
            animationName,

            namespace,
            moduleNamespace,
            module
            ;

            module = {

                initialize: function() {
                    // get settings
                    settings        = module.get.settings.apply(element, moduleArguments);
                    module.verbose('Converted arguments into settings object', settings);

                    // set shortcuts
                    error           = settings.error;
                    className       = settings.className;
                    namespace       = settings.namespace;
                    metadata        = settings.metadata;
                    moduleNamespace = 'module-' + namespace;

                    animationEnd    = module.get.animationEvent();
                    animationName   = module.get.animationName();

                    instance        = $module.data(moduleNamespace) || module;

                    if(methodInvoked) {
                        methodInvoked = module.invoke(query);
                    }
                    // no internal method was found matching query or query not made
                    if(methodInvoked === false) {
                        module.animate();
                    }
                    module.instantiate();
                },

                instantiate: function() {
                    module.verbose('Storing instance of module', module);
                    $module
                    .data(moduleNamespace, instance)
                    ;
                },

                destroy: function() {
                    module.verbose('Destroying previous module for', element);
                    $module
                    .removeData(moduleNamespace)
                    ;
                },

                refresh: function() {
                    module.verbose('Refreshing display type on next animation');
                    delete instance.displayType;
                },

                forceRepaint: function() {
                    module.verbose('Forcing element repaint');
                    var
                    $parentElement = $module.parent(),
                    $nextElement = $module.next()
                    ;
                    if($nextElement.size() === 0) {
                        $module.detach().appendTo($parentElement);
                    }
                    else {
                        $module.detach().insertBefore($nextElement);
                    }
                },

                repaint: function() {
                    module.verbose('Repainting element');
                    var
                    fakeAssignment = element.offsetWidth
                    ;
                },

                animate: function(overrideSettings) {
                    settings = overrideSettings || settings;
                    if(!module.is.supported()) {
                        module.error(error.support);
                        return false;
                    }
                    module.debug('Preparing animation', settings.animation);
                    if(module.is.animating() && settings.queue) {
                        if(!settings.allowRepeats && module.has.direction() && module.is.occuring() && instance.queuing !== true) {
                            module.error(error.repeated);
                        }
                        else {
                            module.queue(settings.animation);
                        }
                        return false;
                    }
                    if(module.can.animate) {
                        module.set.animating(settings.animation);
                    }
                    else {
                        module.error(error.noAnimation, settings.animation);
                    }
                },

                reset: function() {
                    module.debug('Resetting animation to beginning conditions');
                    $module.off(animationEnd);
                    module.restore.conditions();
                    module.hide();
                    module.remove.animating();
                },

                queue: function(animation) {
                    module.debug('Queueing animation of', animation);
                    instance.queuing = true;
                    $module
                    .one(animationEnd, function() {
                        instance.queuing = false;
                        module.repaint();
                        module.animate.apply(this, settings);
                    })
                    ;
                },

                complete: function () {
                    module.verbose('CSS animation complete', settings.animation);
                    if(!module.is.looping()) {
                        if( module.is.outward() ) {
                            module.verbose('Animation is outward, hiding element');
                            module.restore.conditions();
                            module.remove.display();
                            module.hide();
                            $.proxy(settings.onHide, this)();
                        }
                        else if( module.is.inward() ) {
                            module.verbose('Animation is outward, showing element');
                            module.restore.conditions();
                            module.show();
                            $.proxy(settings.onShow, this)();
                        }
                        else {
                            module.restore.conditions();
                        }
                        module.remove.duration();
                        module.remove.animating();
                    }
                    $.proxy(settings.complete, this)();
                },

                has: {
                    direction: function(animation) {
                        animation = animation || settings.animation;
                        if( animation.search(className.inward) !== -1 || animation.search(className.outward) !== -1) {
                            module.debug('Direction already set in animation');
                            return true;
                        }
                        return false;
                    }
                },

                set: {

                    animating: function(animation) {
                        animation = animation || settings.animation;
                        module.save.conditions();
                        if(module.can.transition() && !module.has.direction()) {
                            module.set.direction();
                        }
                        module.remove.hidden();
                        module.set.display();
                        $module
                        .addClass(className.animating)
                        .addClass(className.transition)
                        .addClass(animation)
                        .one(animationEnd, module.complete)
                        ;
                        module.set.duration(settings.duration);
                        module.debug('Starting tween', settings.animation, $module.attr('class'));
                    },

                    display: function() {
                        var
                        displayType = module.get.displayType()
                        ;
                        if(displayType !== 'block' && displayType !== 'none') {
                            module.verbose('Setting final visibility to', displayType);
                            $module
                            .css({
                                display: displayType
                            })
                            ;
                        }
                    },

                    direction: function() {
                        if($module.is(':visible')) {
                            module.debug('Automatically determining the direction of animation', 'Outward');
                            $module
                            .removeClass(className.inward)
                            .addClass(className.outward)
                            ;
                        }
                        else {
                            module.debug('Automatically determining the direction of animation', 'Inward');
                            $module
                            .removeClass(className.outward)
                            .addClass(className.inward)
                            ;
                        }
                    },

                    looping: function() {
                        module.debug('Transition set to loop');
                        $module
                        .addClass(className.looping)
                        ;
                    },

                    duration: function(duration) {
                        duration = duration || settings.duration;
                        duration = (typeof duration == 'number')
                        ? duration + 'ms'
                        : duration
                        ;
                        module.verbose('Setting animation duration', duration);
                        $module
                        .css({
                            '-webkit-animation-duration': duration,
                            '-moz-animation-duration': duration,
                            '-ms-animation-duration': duration,
                            '-o-animation-duration': duration,
                            'animation-duration': duration
                        })
                        ;
                    },

                    hidden: function() {
                        $module
                        .addClass(className.transition)
                        .addClass(className.hidden)
                        ;
                    },

                    visible: function() {
                        $module
                        .addClass(className.transition)
                        .addClass(className.visible)
                        ;
                    }
                },

                save: {
                    displayType: function(displayType) {
                        instance.displayType = displayType;
                    },
                    transitionExists: function(animation, exists) {
                        $.fn.transition.exists[animation] = exists;
                        module.verbose('Saving existence of transition', animation, exists);
                    },
                    conditions: function() {
                        instance.cache = {
                            className : $module.attr('class'),
                            style     : $module.attr('style')
                        };
                        module.verbose('Saving original attributes', instance.cache);
                    }
                },

                restore: {
                    conditions: function() {
                        if(instance.cache === undefined) {
                            return false;
                        }
                        if(instance.cache.className) {
                            $module.attr('class', instance.cache.className);
                        }
                        else {
                            $module.removeAttr('class');
                        }
                        if(instance.cache.style) {
                            $module.attr('style', instance.cache.style);
                        }
                        else {
                            if(module.get.displayType() === 'block') {
                                $module.removeAttr('style');
                            }
                        }
                        if(module.is.looping()) {
                            module.remove.looping();
                        }
                        module.verbose('Restoring original attributes', instance.cache);
                    }
                },

                remove: {

                    animating: function() {
                        $module.removeClass(className.animating);
                    },

                    display: function() {
                        if(instance.displayType !== undefined) {
                            $module.css('display', '');
                        }
                    },

                    duration: function() {
                        $module
                        .css({
                            '-webkit-animation-duration' : '',
                            '-moz-animation-duration'    : '',
                            '-ms-animation-duration'     : '',
                            '-o-animation-duration'      : '',
                            'animation-duration'         : ''
                        })
                        ;
                    },

                    hidden: function() {
                        $module.removeClass(className.hidden);
                    },

                    visible: function() {
                        $module.removeClass(className.visible);
                    },

                    looping: function() {
                        module.debug('Transitions are no longer looping');
                        $module
                        .removeClass(className.looping)
                        ;
                        module.forceRepaint();
                    }

                },

                get: {

                    settings: function(animation, duration, complete) {
                        // single settings object
                        if(typeof animation == 'object') {
                            return $.extend(true, {}, $.fn.transition.settings, animation);
                        }
                        // all arguments provided
                        else if(typeof complete == 'function') {
                            return $.extend({}, $.fn.transition.settings, {
                                animation : animation,
                                complete  : complete,
                                duration  : duration
                            });
                        }
                        // only duration provided
                        else if(typeof duration == 'string' || typeof duration == 'number') {
                            return $.extend({}, $.fn.transition.settings, {
                                animation : animation,
                                duration  : duration
                            });
                        }
                        // duration is actually settings object
                        else if(typeof duration == 'object') {
                            return $.extend({}, $.fn.transition.settings, duration, {
                                animation : animation
                            });
                        }
                        // duration is actually callback
                        else if(typeof duration == 'function') {
                            return $.extend({}, $.fn.transition.settings, {
                                animation : animation,
                                complete  : duration
                            });
                        }
                        // only animation provided
                        else {
                            return $.extend({}, $.fn.transition.settings, {
                                animation : animation
                            });
                        }
                        return $.fn.transition.settings;
                    },

                    displayType: function() {
                        if(instance.displayType === undefined) {
                            // create fake element to determine display state
                            module.can.transition();
                        }
                        return instance.displayType;
                    },

                    transitionExists: function(animation) {
                        return $.fn.transition.exists[animation];
                    },

                    animationName: function() {
                        var
                        element     = document.createElement('div'),
                        animations  = {
                            'animation'       :'animationName',
                            'OAnimation'      :'oAnimationName',
                            'MozAnimation'    :'mozAnimationName',
                            'WebkitAnimation' :'webkitAnimationName'
                        },
                        animation
                        ;
                        for(animation in animations){
                            if( element.style[animation] !== undefined ){
                                module.verbose('Determined animation vendor name property', animations[animation]);
                                return animations[animation];
                            }
                        }
                        return false;
                    },

                    animationEvent: function() {
                        var
                        element     = document.createElement('div'),
                        animations  = {
                            'animation'       :'animationend',
                            'OAnimation'      :'oAnimationEnd',
                            'MozAnimation'    :'animationend',
                            'WebkitAnimation' :'webkitAnimationEnd'
                        },
                        animation
                        ;
                        for(animation in animations){
                            if( element.style[animation] !== undefined ){
                                module.verbose('Determined animation vendor end event', animations[animation]);
                                return animations[animation];
                            }
                        }
                        return false;
                    }

                },

                can: {
                    animate: function() {
                        if($module.css(settings.animation) !== 'none') {
                            module.debug('CSS definition found',  $module.css(settings.animation));
                            return true;
                        }
                        else {
                            module.debug('Unable to find css definition', $module.attr('class'));
                            return false;
                        }
                    },
                    transition: function() {
                        var
                        elementClass     = $module.attr('class'),
                        animation        = settings.animation,
                        transitionExists = module.get.transitionExists(settings.animation),
                        $clone,
                        currentAnimation,
                        inAnimation,
                        displayType
                        ;
                        if( transitionExists === undefined || instance.displayType === undefined) {
                            module.verbose('Determining whether animation exists');
                            $clone = $('<div>').addClass( elementClass ).appendTo($('body'));
                            currentAnimation = $clone
                            .removeClass(className.inward)
                            .removeClass(className.outward)
                            .addClass(className.animating)
                            .addClass(className.transition)
                            .addClass(animation)
                            .css(animationName)
                            ;
                            inAnimation = $clone
                            .addClass(className.inward)
                            .css(animationName)
                            ;
                            displayType = $clone
                            .attr('class', elementClass)
                            .show()
                            .css('display')
                            ;
                            module.verbose('Determining final display state', displayType);
                            if(currentAnimation != inAnimation) {
                                module.debug('Transition exists for animation', animation);
                                transitionExists = true;
                            }
                            else {
                                module.debug('Static animation found', animation, displayType);
                                transitionExists = false;
                            }
                            $clone.remove();
                            module.save.displayType(displayType);
                            module.save.transitionExists(animation, transitionExists);
                        }
                        return transitionExists;
                    }
                },

                is: {
                    animating: function() {
                        return $module.hasClass(className.animating);
                    },
                    inward: function() {
                        return $module.hasClass(className.inward);
                    },
                    outward: function() {
                        return $module.hasClass(className.outward);
                    },
                    looping: function() {
                        return $module.hasClass(className.looping);
                    },
                    occuring: function(animation) {
                        animation = animation || settings.animation;
                        return ( $module.hasClass(animation) );
                    },
                    visible: function() {
                        return $module.is(':visible');
                    },
                    supported: function() {
                        return(animationName !== false && animationEnd !== false);
                    }
                },

                hide: function() {
                    module.verbose('Hiding element');
                    module.remove.visible();
                    module.set.hidden();
                    module.repaint();
                },

                show: function(display) {
                    module.verbose('Showing element', display);
                    module.remove.hidden();
                    module.set.visible();
                    module.repaint();
                },

                start: function() {
                    module.verbose('Starting animation');
                    $module.removeClass(className.disabled);
                },

                stop: function() {
                    module.debug('Stopping animation');
                    $module.addClass(className.disabled);
                },

                toggle: function() {
                    module.debug('Toggling play status');
                    $module.toggleClass(className.disabled);
                },

                setting: function(name, value) {
                    if( $.isPlainObject(name) ) {
                        $.extend(true, settings, name);
                    }
                    else if(value !== undefined) {
                        settings[name] = value;
                    }
                    else {
                        return settings[name];
                    }
                },
                internal: function(name, value) {
                    if( $.isPlainObject(name) ) {
                        $.extend(true, module, name);
                    }
                    else if(value !== undefined) {
                        module[name] = value;
                    }
                    else {
                        return module[name];
                    }
                },
                debug: function() {
                    if(settings.debug) {
                        if(settings.performance) {
                            module.performance.log(arguments);
                        }
                        else {
                            module.debug = Function.prototype.bind.call(console.info, console, settings.name + ':');
                            module.debug.apply(console, arguments);
                        }
                    }
                },
                verbose: function() {
                    if(settings.verbose && settings.debug) {
                        if(settings.performance) {
                            module.performance.log(arguments);
                        }
                        else {
                            module.verbose = Function.prototype.bind.call(console.info, console, settings.name + ':');
                            module.verbose.apply(console, arguments);
                        }
                    }
                },
                error: function() {
                    module.error = Function.prototype.bind.call(console.error, console, settings.name + ':');
                    module.error.apply(console, arguments);
                },
                performance: {
                    log: function(message) {
                        var
                        currentTime,
                        executionTime,
                        previousTime
                        ;
                        if(settings.performance) {
                            currentTime   = new Date().getTime();
                            previousTime  = time || currentTime;
                            executionTime = currentTime - previousTime;
                            time          = currentTime;
                            performance.push({
                                'Element'        : element,
                                'Name'           : message[0],
                                'Arguments'      : [].slice.call(message, 1) || '',
                                'Execution Time' : executionTime
                            });
                        }
                        clearTimeout(module.performance.timer);
                        module.performance.timer = setTimeout(module.performance.display, 100);
                    },
                    display: function() {
                        var
                        title = settings.name + ':',
                        totalTime = 0
                        ;
                        time = false;
                        clearTimeout(module.performance.timer);
                        $.each(performance, function(index, data) {
                            totalTime += data['Execution Time'];
                        });
                        title += ' ' + totalTime + 'ms';
                        if(moduleSelector) {
                            title += ' \'' + moduleSelector + '\'';
                        }
                        if($allModules.size() > 1) {
                            title += ' ' + '(' + $allModules.size() + ')';
                        }
                        if( (console.group !== undefined || console.table !== undefined) && performance.length > 0) {
                            console.groupCollapsed(title);
                            if(console.table) {
                                console.table(performance);
                            }
                            else {
                                $.each(performance, function(index, data) {
                                    console.log(data['Name'] + ': ' + data['Execution Time']+'ms');
                                });
                            }
                            console.groupEnd();
                        }
                        performance = [];
                    }
                },
                invoke: function(query, passedArguments, context) {
                    var
                    object = instance,
                    maxDepth,
                    found,
                    response
                    ;
                    passedArguments = passedArguments || queryArguments;
                    context         = element         || context;
                    if(typeof query == 'string' && object !== undefined) {
                        query    = query.split(/[\. ]/);
                        maxDepth = query.length - 1;
                        $.each(query, function(depth, value) {
                            var camelCaseValue = (depth != maxDepth)
                            ? value + query[depth + 1].charAt(0).toUpperCase() + query[depth + 1].slice(1)
                            : query
                            ;
                            if( $.isPlainObject( object[camelCaseValue] ) && (depth != maxDepth) ) {
                                object = object[camelCaseValue];
                            }
                            else if( object[camelCaseValue] !== undefined ) {
                                found = object[camelCaseValue];
                                return false;
                            }
                            else if( $.isPlainObject( object[value] ) && (depth != maxDepth) ) {
                                object = object[value];
                            }
                            else if( object[value] !== undefined ) {
                                found = object[value];
                                return false;
                            }
                            else {
                                return false;
                            }
                        });
                    }
                    if ( $.isFunction( found ) ) {
                        response = found.apply(context, passedArguments);
                    }
                    else if(found !== undefined) {
                        response = found;
                    }
                    if($.isArray(returnedValue)) {
                        returnedValue.push(response);
                    }
                    else if(returnedValue !== undefined) {
                        returnedValue = [returnedValue, response];
                    }
                    else if(response !== undefined) {
                        returnedValue = response;
                    }
                    return found || false;
                }
            };
            module.initialize();
        })
        ;
        return (returnedValue !== undefined)
        ? returnedValue
        : this
        ;
    };

    $.fn.transition.exists = {};

    $.fn.transition.settings = {

        // module info
        name        : 'Transition',

        // debug content outputted to console
        debug       : false,

        // verbose debug output
        verbose     : true,

        // performance data output
        performance : true,

        // event namespace
        namespace   : 'transition',

        // animation complete event
        complete    : function() {},
        onShow      : function() {},
        onHide      : function() {},

        // whether animation can occur twice in a row
        allowRepeats : false,

        // animation duration
        animation  : 'fade',
        duration   : '700ms',

        // new animations will occur after previous ones
        queue       : true,

        className   : {
            animating  : 'animating',
            disabled   : 'disabled',
            hidden     : 'hidden',
            inward     : 'in',
            loading    : 'loading',
            looping    : 'looping',
            outward    : 'out',
            transition : 'ui transition',
            visible    : 'visible'
        },

        // possible errors
        error: {
            noAnimation : 'There is no css animation matching the one you specified.',
            repeated    : 'That animation is already occurring, cancelling repeated animation',
            method      : 'The method you called is not defined',
            support     : 'This browser does not support CSS animations'
        }

    };


})( jQuery, window , document );



/*
 * # Semantic - Accordion
 * http://github.com/jlukic/semantic-ui/
 *
 *
 * Copyright 2013 Contributors
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */

;(function ($, window, document, undefined) {

    $.fn.accordion = function(parameters) {
        var
        $allModules     = $(this),

        time            = new Date().getTime(),
        performance     = [],

        query           = arguments[0],
        methodInvoked   = (typeof query == 'string'),
        queryArguments  = [].slice.call(arguments, 1),
        returnedValue
        ;
        $allModules
        .each(function() {
            var
            settings        = ( $.isPlainObject(parameters) )
            ? $.extend(true, {}, $.fn.accordion.settings, parameters)
            : $.extend({}, $.fn.accordion.settings),

            className       = settings.className,
            namespace       = settings.namespace,
            selector        = settings.selector,
            error           = settings.error,

            eventNamespace  = '.' + namespace,
            moduleNamespace = 'module-' + namespace,
            moduleSelector  = $allModules.selector || '',

            $module  = $(this),
            $title   = $module.find(selector.title),
            $content = $module.find(selector.content),

            element  = this,
            instance = $module.data(moduleNamespace),
            module
            ;

            module = {

                initialize: function() {
                    module.debug('Initializing accordion with bound events', $module);
                    // initializing
                    $title
                    .on('click' + eventNamespace, module.event.click)
                    ;
                    module.instantiate();
                },

                instantiate: function() {
                    instance = module;
                    $module
                    .data(moduleNamespace, module)
                    ;
                },

                destroy: function() {
                    module.debug('Destroying previous accordion for', $module);
                    $module
                    .removeData(moduleNamespace)
                    ;
                    $title
                    .off(eventNamespace)
                    ;
                },

                event: {
                    click: function() {
                        module.verbose('Title clicked', this);
                        var
                        $activeTitle = $(this),
                        index        = $title.index($activeTitle)
                        ;
                        module.toggle(index);
                    },
                    resetDisplay: function() {
                        $(this).css('display', '');
                        if( $(this).attr('style') == '') {
                            $(this)
                            .attr('style', '')
                            .removeAttr('style')
                            ;
                        }
                    },
                    resetOpacity: function() {
                        $(this).css('opacity', '');
                        if( $(this).attr('style') == '') {
                            $(this)
                            .attr('style', '')
                            .removeAttr('style')
                            ;
                        }
                    }
                },

                toggle: function(index) {
                    module.debug('Toggling content content at index', index);
                    var
                    $activeTitle   = $title.eq(index),
                    $activeContent = $activeTitle.next($content),
                    contentIsOpen  = $activeContent.is(':visible')
                    ;
                    if(contentIsOpen) {
                        if(settings.collapsible) {
                            module.close(index);
                        }
                        else {
                            module.debug('Cannot close accordion content collapsing is disabled');
                        }
                    }
                    else {
                        module.open(index);
                    }
                },

                open: function(index) {
                    var
                    $activeTitle     = $title.eq(index),
                    $activeContent   = $activeTitle.next($content),
                    $otherSections   = module.is.menu()
                    ? $activeTitle.parent().siblings(selector.item).find(selector.title)
                    : $activeTitle.siblings(selector.title),
                    $previousTitle   = $otherSections.filter('.' + className.active),
                    $previousContent = $previousTitle.next($title),
                    contentIsOpen    =  ($previousTitle.size() > 0)
                    ;
                    if( !$activeContent.is(':animated') ) {
                        module.debug('Opening accordion content', $activeTitle);
                        if(settings.exclusive && contentIsOpen) {
                            $previousTitle
                            .removeClass(className.active)
                            ;
                            $previousContent
                            .stop()
                            .children()
                            .stop()
                            .animate({
                                opacity: 0
                            }, settings.duration, module.event.resetOpacity)
                            .end()
                            .slideUp(settings.duration , settings.easing, function() {
                                $previousContent
                                .removeClass(className.active)
                                .children()
                                ;
                                $.proxy(module.event.resetDisplay, this)();
                            })
                            ;
                        }
                        $activeTitle
                        .addClass(className.active)
                        ;
                        $activeContent
                        .stop()
                        .children()
                        .stop()
                        .animate({
                            opacity: 1
                        }, settings.duration)
                        .end()
                        .slideDown(settings.duration, settings.easing, function() {
                            $activeContent
                            .addClass(className.active)
                            ;
                            $.proxy(module.event.resetDisplay, this)();
                            $.proxy(settings.onOpen, $activeContent)();
                            $.proxy(settings.onChange, $activeContent)();
                        })
                        ;
                    }
                },

                close: function(index) {
                    var
                    $activeTitle   = $title.eq(index),
                    $activeContent = $activeTitle.next($content)
                    ;
                    module.debug('Closing accordion content', $activeContent);
                    $activeTitle
                    .removeClass(className.active)
                    ;
                    $activeContent
                    .removeClass(className.active)
                    .show()
                    .stop()
                    .children()
                    .stop()
                    .animate({
                        opacity: 0
                    }, settings.duration, module.event.resetOpacity)
                    .end()
                    .slideUp(settings.duration, settings.easing, function(){
                        $.proxy(module.event.resetDisplay, this)();
                        $.proxy(settings.onClose, $activeContent)();
                        $.proxy(settings.onChange, $activeContent)();
                    })
                    ;
                },
                is: {
                    menu: function () {
                        return $module.hasClass(className.menu);
                    }
                },
                setting: function(name, value) {
                    if( $.isPlainObject(name) ) {
                        $.extend(true, settings, name);
                    }
                    else if(value !== undefined) {
                        settings[name] = value;
                    }
                    else {
                        return settings[name];
                    }
                },
                internal: function(name, value) {
                    module.debug('Changing internal', name, value);
                    if(value !== undefined) {
                        if( $.isPlainObject(name) ) {
                            $.extend(true, module, name);
                        }
                        else {
                            module[name] = value;
                        }
                    }
                    else {
                        return module[name];
                    }
                },
                debug: function() {
                    if(settings.debug) {
                        if(settings.performance) {
                            module.performance.log(arguments);
                        }
                        else {
                            module.debug = Function.prototype.bind.call(console.info, console, settings.name + ':');
                            module.debug.apply(console, arguments);
                        }
                    }
                },
                verbose: function() {
                    if(settings.verbose && settings.debug) {
                        if(settings.performance) {
                            module.performance.log(arguments);
                        }
                        else {
                            module.verbose = Function.prototype.bind.call(console.info, console, settings.name + ':');
                            module.verbose.apply(console, arguments);
                        }
                    }
                },
                error: function() {
                    module.error = Function.prototype.bind.call(console.error, console, settings.name + ':');
                    module.error.apply(console, arguments);
                },
                performance: {
                    log: function(message) {
                        var
                        currentTime,
                        executionTime,
                        previousTime
                        ;
                        if(settings.performance) {
                            currentTime   = new Date().getTime();
                            previousTime  = time || currentTime;
                            executionTime = currentTime - previousTime;
                            time          = currentTime;
                            performance.push({
                                'Element'        : element,
                                'Name'           : message[0],
                                'Arguments'      : [].slice.call(message, 1) || '',
                                'Execution Time' : executionTime
                            });
                        }
                        clearTimeout(module.performance.timer);
                        module.performance.timer = setTimeout(module.performance.display, 100);
                    },
                    display: function() {
                        var
                        title = settings.name + ':',
                        totalTime = 0
                        ;
                        time = false;
                        clearTimeout(module.performance.timer);
                        $.each(performance, function(index, data) {
                            totalTime += data['Execution Time'];
                        });
                        title += ' ' + totalTime + 'ms';
                        if(moduleSelector) {
                            title += ' \'' + moduleSelector + '\'';
                        }
                        if( (console.group !== undefined || console.table !== undefined) && performance.length > 0) {
                            console.groupCollapsed(title);
                            if(console.table) {
                                console.table(performance);
                            }
                            else {
                                $.each(performance, function(index, data) {
                                    console.log(data['Name'] + ': ' + data['Execution Time']+'ms');
                                });
                            }
                            console.groupEnd();
                        }
                        performance = [];
                    }
                },
                invoke: function(query, passedArguments, context) {
                    var
                    object = instance,
                    maxDepth,
                    found,
                    response
                    ;
                    passedArguments = passedArguments || queryArguments;
                    context         = element         || context;
                    if(typeof query == 'string' && object !== undefined) {
                        query    = query.split(/[\. ]/);
                        maxDepth = query.length - 1;
                        $.each(query, function(depth, value) {
                            var camelCaseValue = (depth != maxDepth)
                            ? value + query[depth + 1].charAt(0).toUpperCase() + query[depth + 1].slice(1)
                            : query
                            ;
                            if( $.isPlainObject( object[camelCaseValue] ) && (depth != maxDepth) ) {
                                object = object[camelCaseValue];
                            }
                            else if( object[camelCaseValue] !== undefined ) {
                                found = object[camelCaseValue];
                                return false;
                            }
                            else if( $.isPlainObject( object[value] ) && (depth != maxDepth) ) {
                                object = object[value];
                            }
                            else if( object[value] !== undefined ) {
                                found = object[value];
                                return false;
                            }
                            else {
                                return false;
                            }
                        });
                    }
                    if ( $.isFunction( found ) ) {
                        response = found.apply(context, passedArguments);
                    }
                    else if(found !== undefined) {
                        response = found;
                    }
                    if($.isArray(returnedValue)) {
                        returnedValue.push(response);
                    }
                    else if(returnedValue !== undefined) {
                        returnedValue = [returnedValue, response];
                    }
                    else if(response !== undefined) {
                        returnedValue = response;
                    }
                    return found;
                }
            };
            if(methodInvoked) {
                if(instance === undefined) {
                    module.initialize();
                }
                module.invoke(query);
            }
            else {
                if(instance !== undefined) {
                    module.destroy();
                }
                module.initialize();
            }
        })
        ;
        return (returnedValue !== undefined)
        ? returnedValue
        : this
        ;
    };

    $.fn.accordion.settings = {
        name        : 'Accordion',
        namespace   : 'accordion',

        debug       : false,
        verbose     : true,
        performance : true,

        exclusive   : true,
        collapsible : true,

        duration    : 500,
        easing      : 'easeInOutQuint',

        onOpen      : function(){},
        onClose     : function(){},
        onChange    : function(){},

        error: {
            method    : 'The method you called is not defined'
        },

        className   : {
            active : 'active',
            menu   : 'menu'
        },

        selector    : {
            title   : '.title',
            content : '.content',
            menu    : '.menu',
            item    : '.item'
        }


    };

    /*
     * # Semantic - Dropdown
     * http://github.com/jlukic/semantic-ui/
     *
     *
     * Copyright 2013 Contributors
     * Released under the MIT license
     * http://opensource.org/licenses/MIT
     *
     */
    ;(function ( $, window, document, undefined ) {

        $.fn.dropdown = function(parameters) {
            var
            $allModules    = $(this),
            $document      = $(document),

            moduleSelector = $allModules.selector || '',

            hasTouch       = ('ontouchstart' in document.documentElement),
            time           = new Date().getTime(),
            performance    = [],

            query          = arguments[0],
            methodInvoked  = (typeof query == 'string'),
            queryArguments = [].slice.call(arguments, 1),
            returnedValue
            ;

            $allModules
            .each(function() {
                var
                settings          = ( $.isPlainObject(parameters) )
                ? $.extend(true, {}, $.fn.dropdown.settings, parameters)
                : $.extend({}, $.fn.dropdown.settings),

                className       = settings.className,
                metadata        = settings.metadata,
                namespace       = settings.namespace,
                selector        = settings.selector,
                error           = settings.error,

                eventNamespace  = '.' + namespace,
                moduleNamespace = 'module-' + namespace,

                $module         = $(this),
                $item           = $module.find(selector.item),
                $text           = $module.find(selector.text),
                $input          = $module.find(selector.input),

                $menu           = $module.children(selector.menu),


                element         = this,
                instance        = $module.data(moduleNamespace),
                module
                ;

                module = {

                    initialize: function() {
                        module.debug('Initializing dropdown', settings);

                        module.save.defaults();
                        module.set.selected();

                        if(hasTouch) {
                            module.bind.touchEvents();
                        }
                        module.bind.mouseEvents();
                        module.bind.keyboardEvents();
                        module.instantiate();
                    },

                    instantiate: function() {
                        module.verbose('Storing instance of dropdown', module);
                        instance = module;
                        $module
                        .data(moduleNamespace, module)
                        ;
                    },

                    destroy: function() {
                        module.verbose('Destroying previous dropdown for', $module);
                        $item
                        .off(eventNamespace)
                        ;
                        $module
                        .off(eventNamespace)
                        .removeData(moduleNamespace)
                        ;
                    },

                    bind: {
                        keyboardEvents: function() {
                            module.debug('Binding keyboard events');
                            $module
                            .on('keydown' + eventNamespace, module.handleKeyboard)
                            ;
                            $module
                            .on('focus' + eventNamespace, module.show)
                            ;
                        },
                        touchEvents: function() {
                            module.debug('Touch device detected binding touch events');
                            $module
                            .on('touchstart' + eventNamespace, module.event.test.toggle)
                            ;
                            $item
                            .on('touchstart' + eventNamespace, module.event.item.mouseenter)
                            .on('touchstart' + eventNamespace, module.event.item.click)
                            ;
                        },
                        mouseEvents: function() {
                            module.verbose('Mouse detected binding mouse events');
                            if(settings.on == 'click') {
                                $module
                                .on('click' + eventNamespace, module.event.test.toggle)
                                ;
                            }
                            else if(settings.on == 'hover') {
                                $module
                                .on('mouseenter' + eventNamespace, module.delay.show)
                                .on('mouseleave' + eventNamespace, module.delay.hide)
                                ;
                            }
                            else {
                                $module
                                .on(settings.on + eventNamespace, module.toggle)
                                ;
                            }
                            $item
                            .on('mouseenter' + eventNamespace, module.event.item.mouseenter)
                            .on('mouseleave' + eventNamespace, module.event.item.mouseleave)
                            .on('click'      + eventNamespace, module.event.item.click)
                            ;
                        },
                        intent: function() {
                            module.verbose('Binding hide intent event to document');
                            if(hasTouch) {
                                $document
                                .on('touchstart' + eventNamespace, module.event.test.touch)
                                .on('touchmove'  + eventNamespace, module.event.test.touch)
                                ;
                            }
                            $document
                            .on('click' + eventNamespace, module.event.test.hide)
                            ;
                        }
                    },

                    unbind: {
                        intent: function() {
                            module.verbose('Removing hide intent event from document');
                            if(hasTouch) {
                                $document
                                .off('touchstart' + eventNamespace)
                                .off('touchmove' + eventNamespace)
                                ;
                            }
                            $document
                            .off('click' + eventNamespace)
                            ;
                        }
                    },

                    handleKeyboard: function(event) {
                        var
                        $selectedItem = $item.filter('.' + className.selected),
                        pressedKey    = event.which,
                        keys          = {
                            enter     : 13,
                            escape    : 27,
                            upArrow   : 38,
                            downArrow : 40
                        },
                        selectedClass   = className.selected,
                        currentIndex    = $item.index( $selectedItem ),
                        hasSelectedItem = ($selectedItem.size() > 0),
                        resultSize      = $item.size(),
                        newIndex
                        ;
                        // close shortcuts
                        if(pressedKey == keys.escape) {
                            module.verbose('Escape key pressed, closing dropdown');
                            module.hide();
                        }
                        // result shortcuts
                        if(module.is.visible()) {
                            if(pressedKey == keys.enter && hasSelectedItem) {
                                module.verbose('Enter key pressed, choosing selected item');
                                $.proxy(module.event.item.click, $item.filter('.' + selectedClass) )(event);
                                event.preventDefault();
                                return false;
                            }
                            else if(pressedKey == keys.upArrow) {
                                module.verbose('Up key pressed, changing active item');
                                newIndex = (currentIndex - 1 < 0)
                                ? currentIndex
                                : currentIndex - 1
                                ;
                                $item
                                .removeClass(selectedClass)
                                .eq(newIndex)
                                .addClass(selectedClass)
                                ;
                                event.preventDefault();
                            }
                            else if(pressedKey == keys.downArrow) {
                                module.verbose('Down key pressed, changing active item');
                                newIndex = (currentIndex + 1 >= resultSize)
                                ? currentIndex
                                : currentIndex + 1
                                ;
                                $item
                                .removeClass(selectedClass)
                                .eq(newIndex)
                                .addClass(selectedClass)
                                ;
                                event.preventDefault();
                            }
                        }
                        else {
                            if(pressedKey == keys.enter) {
                                module.show();
                            }
                        }
                    },

                    event: {
                        test: {
                            toggle: function(event) {
                                if( module.determine.intent(event, module.toggle) ) {
                                    event.preventDefault();
                                }
                            },
                            touch: function(event) {
                                module.determine.intent(event, function() {
                                    if(event.type == 'touchstart') {
                                        module.timer = setTimeout(module.hide, settings.delay.touch);
                                    }
                                    else if(event.type == 'touchmove') {
                                        clearTimeout(module.timer);
                                    }
                                });
                                event.stopPropagation();
                            },
                            hide: function(event) {
                                module.determine.intent(event, module.hide);
                            }
                        },

                        item: {

                            mouseenter: function(event) {
                                var
                                $currentMenu = $(this).find(selector.submenu),
                                $otherMenus  = $(this).siblings(selector.item).children(selector.menu)
                                ;
                                if($currentMenu.length > 0  || $otherMenus.length > 0) {
                                    clearTimeout(module.itemTimer);
                                    module.itemTimer = setTimeout(function() {
                                        if($otherMenus.length > 0) {
                                            module.animate.hide(false, $otherMenus.filter(':visible'));
                                        }
                                        if($currentMenu.length > 0) {
                                            module.verbose('Showing sub-menu', $currentMenu);
                                            module.animate.show(false, $currentMenu);
                                        }
                                    }, settings.delay.show * 2);
                                    event.preventDefault();
                                    event.stopPropagation();
                                }
                            },

                            mouseleave: function(event) {
                                var
                                $currentMenu = $(this).find(selector.menu)
                                ;
                                if($currentMenu.size() > 0) {
                                    clearTimeout(module.itemTimer);
                                    module.itemTimer = setTimeout(function() {
                                        module.verbose('Hiding sub-menu', $currentMenu);
                                        module.animate.hide(false,  $currentMenu);
                                    }, settings.delay.hide);
                                }
                            },

                            click: function (event) {
                                var
                                $choice = $(this),
                                text    = ( $choice.data(metadata.text) !== undefined )
                                ? $choice.data(metadata.text)
                                : $choice.text(),
                                value   = ( $choice.data(metadata.value) !== undefined)
                                ? $choice.data(metadata.value)
                                : (typeof text === 'string')
                                ? text.toLowerCase()
                                : text,
                                callback = function() {
                                    module.determine.selectAction(text, value);
                                    $.proxy(settings.onChange, element)(value, text);
                                }
                                ;
                                if( $choice.find(selector.menu).size() === 0 ) {
                                    if(event.type == 'touchstart') {
                                        $choice.one('click', callback);
                                    }
                                    else {
                                        callback();
                                    }
                                }
                            }

                        },

                        resetStyle: function() {
                            $(this).removeAttr('style');
                        }

                    },

                    determine: {
                        selectAction: function(text, value) {
                            module.verbose('Determining action', settings.action);
                            if( $.isFunction( module.action[settings.action] ) ) {
                                module.verbose('Triggering preset action', settings.action, text, value);
                                module.action[ settings.action ](text, value);
                            }
                            else if( $.isFunction(settings.action) ) {
                                module.verbose('Triggering user action', settings.action, text, value);
                                settings.action(text, value);
                            }
                            else {
                                module.error(error.action, settings.action);
                            }
                        },
                        intent: function(event, callback) {
                            module.debug('Determining whether event occurred in dropdown', event.target);
                            callback = callback || function(){};
                            if( $(event.target).closest($menu).size() === 0 ) {
                                module.verbose('Triggering event', callback);
                                callback();
                                return true;
                            }
                            else {
                                module.verbose('Event occurred in dropdown, canceling callback');
                                return false;
                            }
                        }
                    },

                    action: {

                        nothing: function() {},

                        hide: function() {
                            module.hide();
                        },

                        activate: function(text, value) {
                            value = (value !== undefined)
                            ? value
                            : text
                            ;
                            module.set.selected(value);
                            module.set.value(value);
                            module.hide();
                        },

                        /* Deprecated */
                        auto: function(text, value) {
                            value = (value !== undefined)
                            ? value
                            : text
                            ;
                            module.set.selected(value);
                            module.set.value(value);
                            module.hide();
                        },

                        /* Deprecated */
                        changeText: function(text, value) {
                            value = (value !== undefined)
                            ? value
                            : text
                            ;
                            module.set.selected(value);
                            module.hide();
                        },

                        /* Deprecated */
                        updateForm: function(text, value) {
                            value = (value !== undefined)
                            ? value
                            : text
                            ;
                            module.set.selected(value);
                            module.set.value(value);
                            module.hide();
                        }

                    },

                    get: {
                        text: function() {
                            return $text.text();
                        },
                        value: function() {
                            return ($input.size() > 0)
                            ? $input.val()
                            : $module.data(metadata.value)
                            ;
                        },
                        item: function(value, strict) {
                            var
                            $selectedItem = false
                            ;
                            value = (value !== undefined)
                            ? value
                            : ( module.get.value() !== undefined)
                            ? module.get.value()
                            : module.get.text()
                            ;
                            if(strict === undefined && value === '') {
                                module.debug('Ambiguous dropdown value using strict type check', value);
                                strict = true;
                            }
                            else {
                                strict = strict || false;
                            }
                            if(value !== undefined) {
                                $item
                                .each(function() {
                                    var
                                    $choice       = $(this),
                                    optionText    = ( $choice.data(metadata.text) !== undefined )
                                    ? $choice.data(metadata.text)
                                    : $choice.text(),
                                    optionValue   = ( $choice.data(metadata.value) !== undefined )
                                    ? $choice.data(metadata.value)
                                    : (typeof optionText === 'string')
                                    ? optionText.toLowerCase()
                                    : optionText
                                    ;
                                    if(strict) {
                                        if( optionValue === value ) {
                                            $selectedItem = $(this);
                                        }
                                        else if( !$selectedItem && optionText === value ) {
                                            $selectedItem = $(this);
                                        }
                                    }
                                    else {
                                        if( optionValue == value ) {
                                            $selectedItem = $(this);
                                        }
                                        else if( !$selectedItem && optionText == value ) {
                                            $selectedItem = $(this);
                                        }
                                    }
                                })
                                ;
                            }
                            else {
                                value = module.get.text();
                            }
                            return $selectedItem || false;
                        }
                    },

                    restore: {
                        defaults: function() {
                            module.restore.defaultText();
                            module.restore.defaultValue();
                        },
                        defaultText: function() {
                            var
                            defaultText = $module.data(metadata.defaultText)
                            ;
                            module.debug('Restoring default text', defaultText);
                            module.set.text(defaultText);
                        },
                        defaultValue: function() {
                            var
                            defaultValue = $module.data(metadata.defaultValue)
                            ;
                            if(defaultValue !== undefined) {
                                module.debug('Restoring default value', defaultValue);
                                module.set.selected(defaultValue);
                                module.set.value(defaultValue);
                            }
                        }
                    },

                    save: {
                        defaults: function() {
                            module.save.defaultText();
                            module.save.defaultValue();
                        },
                        defaultValue: function() {
                            $module.data(metadata.defaultValue, module.get.value() );
                        },
                        defaultText: function() {
                            $module.data(metadata.defaultText, $text.text() );
                        }
                    },

                    set: {
                        text: function(text) {
                            module.debug('Changing text', text, $text);
                            $text.removeClass(className.placeholder);
                            $text.text(text);
                        },
                        value: function(value) {
                            module.debug('Adding selected value to hidden input', value, $input);
                            if($input.size() > 0) {
                                $input
                                .val(value)
                                .trigger('change')
                                ;
                            }
                            else {
                                $module.data(metadata.value, value);
                            }
                        },
                        active: function() {
                            $module.addClass(className.active);
                        },
                        visible: function() {
                            $module.addClass(className.visible);
                        },
                        selected: function(value) {
                            var
                            $selectedItem = module.get.item(value),
                            selectedText
                            ;
                            if($selectedItem) {
                                module.debug('Setting selected menu item to', $selectedItem);
                                selectedText = ($selectedItem.data(metadata.text) !== undefined)
                                ? $selectedItem.data(metadata.text)
                                : $selectedItem.text()
                                ;
                                $item
                                .removeClass(className.active)
                                ;
                                $selectedItem
                                .addClass(className.active)
                                ;
                                module.set.text(selectedText);
                            }
                        }
                    },

                    remove: {
                        active: function() {
                            $module.removeClass(className.active);
                        },
                        visible: function() {
                            $module.removeClass(className.visible);
                        }
                    },

                    is: {
                        selection: function() {
                            return $module.hasClass(className.selection);
                        },
                        animated: function($subMenu) {
                            return ($subMenu)
                            ? $subMenu.is(':animated') || $subMenu.transition && $subMenu.transition('is animating')
                            : $menu.is(':animated') || $menu.transition && $menu.transition('is animating')
                            ;
                        },
                        visible: function($subMenu) {
                            return ($subMenu)
                            ? $subMenu.is(':visible')
                            : $menu.is(':visible')
                            ;
                        },
                        hidden: function($subMenu) {
                            return ($subMenu)
                            ? $subMenu.is(':not(:visible)')
                            : $menu.is(':not(:visible)')
                            ;
                        }
                    },

                    can: {
                        click: function() {
                            return (hasTouch || settings.on == 'click');
                        },
                        show: function() {
                            return !$module.hasClass(className.disabled);
                        }
                    },

                    animate: {
                        show: function(callback, $subMenu) {
                            var
                            $currentMenu = $subMenu || $menu
                            ;
                            callback = callback || function(){};
                            if( module.is.hidden($currentMenu) ) {
                                module.verbose('Doing menu show animation', $currentMenu);
                                if(settings.transition == 'none') {
                                    callback();
                                }
                                else if($.fn.transition !== undefined && $module.transition('is supported')) {
                                    $currentMenu
                                    .transition({
                                        animation : settings.transition + ' in',
                                        duration  : settings.duration,
                                        complete  : callback,
                                        queue     : false
                                    })
                                    ;
                                }
                                else if(settings.transition == 'slide down') {
                                    $currentMenu
                                    .hide()
                                    .clearQueue()
                                    .children()
                                    .clearQueue()
                                    .css('opacity', 0)
                                    .delay(50)
                                    .animate({
                                        opacity : 1
                                    }, settings.duration, 'easeOutQuad', module.event.resetStyle)
                                    .end()
                                    .slideDown(100, 'easeOutQuad', function() {
                                        $.proxy(module.event.resetStyle, this)();
                                        callback();
                                    })
                                    ;
                                }
                                else if(settings.transition == 'fade') {
                                    $currentMenu
                                    .hide()
                                    .clearQueue()
                                    .fadeIn(settings.duration, function() {
                                        $.proxy(module.event.resetStyle, this)();
                                        callback();
                                    })
                                    ;
                                }
                                else {
                                    module.error(error.transition, settings.transition);
                                }
                            }
                        },
                        hide: function(callback, $subMenu) {
                            var
                            $currentMenu = $subMenu || $menu
                            ;
                            callback = callback || function(){};
                            if(module.is.visible($currentMenu) ) {
                                module.verbose('Doing menu hide animation', $currentMenu);
                                if($.fn.transition !== undefined && $module.transition('is supported')) {
                                    $currentMenu
                                    .transition({
                                        animation : settings.transition + ' out',
                                        duration  : settings.duration,
                                        complete  : callback,
                                        queue     : false
                                    })
                                    ;
                                }
                                else if(settings.transition == 'none') {
                                    callback();
                                }
                                else if(settings.transition == 'slide down') {
                                    $currentMenu
                                    .show()
                                    .clearQueue()
                                    .children()
                                    .clearQueue()
                                    .css('opacity', 1)
                                    .animate({
                                        opacity : 0
                                    }, 100, 'easeOutQuad', module.event.resetStyle)
                                    .end()
                                    .delay(50)
                                    .slideUp(100, 'easeOutQuad', function() {
                                        $.proxy(module.event.resetStyle, this)();
                                        callback();
                                    })
                                    ;
                                }
                                else if(settings.transition == 'fade') {
                                    $currentMenu
                                    .show()
                                    .clearQueue()
                                    .fadeOut(150, function() {
                                        $.proxy(module.event.resetStyle, this)();
                                        callback();
                                    })
                                    ;
                                }
                                else {
                                    module.error(error.transition);
                                }
                            }
                        }
                    },

                    show: function() {
                        module.debug('Checking if dropdown can show');
                        if( module.is.hidden() ) {
                            module.hideOthers();
                            module.set.active();
                            module.animate.show(function() {
                                if( module.can.click() ) {
                                    module.bind.intent();
                                }
                                module.set.visible();
                            });
                            $.proxy(settings.onShow, element)();
                        }
                    },

                    hide: function() {
                        if( !module.is.animated() && module.is.visible() ) {
                            module.debug('Hiding dropdown');
                            if( module.can.click() ) {
                                module.unbind.intent();
                            }
                            module.remove.active();
                            module.animate.hide(module.remove.visible);
                            $.proxy(settings.onHide, element)();
                        }
                    },

                    delay: {
                        show: function() {
                            module.verbose('Delaying show event to ensure user intent');
                            clearTimeout(module.timer);
                            module.timer = setTimeout(module.show, settings.delay.show);
                        },
                        hide: function() {
                            module.verbose('Delaying hide event to ensure user intent');
                            clearTimeout(module.timer);
                            module.timer = setTimeout(module.hide, settings.delay.hide);
                        }
                    },

                    hideOthers: function() {
                        module.verbose('Finding other dropdowns to hide');
                        $allModules
                        .not($module)
                        .has(selector.menu + ':visible')
                        .dropdown('hide')
                        ;
                    },

                    toggle: function() {
                        module.verbose('Toggling menu visibility');
                        if( module.is.hidden() ) {
                            module.show();
                        }
                        else {
                            module.hide();
                        }
                    },

                    setting: function(name, value) {
                        if( $.isPlainObject(name) ) {
                            $.extend(true, settings, name);
                        }
                        else if(value !== undefined) {
                            settings[name] = value;
                        }
                        else {
                            return settings[name];
                        }
                    },
                    internal: function(name, value) {
                        if( $.isPlainObject(name) ) {
                            $.extend(true, module, name);
                        }
                        else if(value !== undefined) {
                            module[name] = value;
                        }
                        else {
                            return module[name];
                        }
                    },
                    debug: function() {
                        if(settings.debug) {
                            if(settings.performance) {
                                module.performance.log(arguments);
                            }
                            else {
                                module.debug = Function.prototype.bind.call(console.info, console, settings.name + ':');
                                module.debug.apply(console, arguments);
                            }
                        }
                    },
                    verbose: function() {
                        if(settings.verbose && settings.debug) {
                            if(settings.performance) {
                                module.performance.log(arguments);
                            }
                            else {
                                module.verbose = Function.prototype.bind.call(console.info, console, settings.name + ':');
                                module.verbose.apply(console, arguments);
                            }
                        }
                    },
                    error: function() {
                        module.error = Function.prototype.bind.call(console.error, console, settings.name + ':');
                        module.error.apply(console, arguments);
                    },
                    performance: {
                        log: function(message) {
                            var
                            currentTime,
                            executionTime,
                            previousTime
                            ;
                            if(settings.performance) {
                                currentTime   = new Date().getTime();
                                previousTime  = time || currentTime;
                                executionTime = currentTime - previousTime;
                                time          = currentTime;
                                performance.push({
                                    'Element'        : element,
                                    'Name'           : message[0],
                                    'Arguments'      : [].slice.call(message, 1) || '',
                                    'Execution Time' : executionTime
                                });
                            }
                            clearTimeout(module.performance.timer);
                            module.performance.timer = setTimeout(module.performance.display, 100);
                        },
                        display: function() {
                            var
                            title = settings.name + ':',
                            totalTime = 0
                            ;
                            time = false;
                            clearTimeout(module.performance.timer);
                            $.each(performance, function(index, data) {
                                totalTime += data['Execution Time'];
                            });
                            title += ' ' + totalTime + 'ms';
                            if(moduleSelector) {
                                title += ' \'' + moduleSelector + '\'';
                            }
                            if( (console.group !== undefined || console.table !== undefined) && performance.length > 0) {
                                console.groupCollapsed(title);
                                if(console.table) {
                                    console.table(performance);
                                }
                                else {
                                    $.each(performance, function(index, data) {
                                        console.log(data['Name'] + ': ' + data['Execution Time']+'ms');
                                    });
                                }
                                console.groupEnd();
                            }
                            performance = [];
                        }
                    },
                    invoke: function(query, passedArguments, context) {
                        var
                        object = instance,
                        maxDepth,
                        found,
                        response
                        ;
                        passedArguments = passedArguments || queryArguments;
                        context         = element         || context;
                        if(typeof query == 'string' && object !== undefined) {
                            query    = query.split(/[\. ]/);
                            maxDepth = query.length - 1;
                            $.each(query, function(depth, value) {
                                var camelCaseValue = (depth != maxDepth)
                                ? value + query[depth + 1].charAt(0).toUpperCase() + query[depth + 1].slice(1)
                                : query
                                ;
                                if( $.isPlainObject( object[camelCaseValue] ) && (depth != maxDepth) ) {
                                    object = object[camelCaseValue];
                                }
                                else if( object[camelCaseValue] !== undefined ) {
                                    found = object[camelCaseValue];
                                    return false;
                                }
                                else if( $.isPlainObject( object[value] ) && (depth != maxDepth) ) {
                                    object = object[value];
                                }
                                else if( object[value] !== undefined ) {
                                    found = object[value];
                                    return false;
                                }
                                else {
                                    module.error(error.method, query);
                                    return false;
                                }
                            });
                        }
                        if ( $.isFunction( found ) ) {
                            response = found.apply(context, passedArguments);
                        }
                        else if(found !== undefined) {
                            response = found;
                        }
                        if($.isArray(returnedValue)) {
                            returnedValue.push(response);
                        }
                        else if(returnedValue !== undefined) {
                            returnedValue = [returnedValue, response];
                        }
                        else if(response !== undefined) {
                            returnedValue = response;
                        }
                        return found;
                    }
                };

                if(methodInvoked) {
                    if(instance === undefined) {
                        module.initialize();
                    }
                    module.invoke(query);
                }
                else {
                    if(instance !== undefined) {
                        module.destroy();
                    }
                    module.initialize();
                }
            })
            ;

            return (returnedValue !== undefined)
            ? returnedValue
            : this
            ;
        };

        $.fn.dropdown.settings = {

            name        : 'Dropdown',
            namespace   : 'dropdown',

            debug       : false,
            verbose     : true,
            performance : true,

            on          : 'click',
            action      : 'activate',

            delay: {
                show  : 200,
                hide  : 300,
                touch : 50
            },

            transition : 'slide down',
            duration   : 250,

            onChange : function(value, text){},
            onShow   : function(){},
            onHide   : function(){},

            error   : {
                action    : 'You called a dropdown action that was not defined',
                method    : 'The method you called is not defined.',
                transition : 'The requested transition was not found'
            },

            metadata: {
                defaultText  : 'defaultText',
                defaultValue : 'defaultValue',
                text         : 'text',
                value        : 'value'
            },

            selector : {
                menu    : '.menu',
                submenu : '> .menu',
                item    : '.menu > .item',
                text    : '> .text',
                input   : '> input[type="hidden"]'
            },

            className : {
                active      : 'active',
                placeholder : 'default',
                disabled    : 'disabled',
                visible     : 'visible',
                selected    : 'selected',
                selection   : 'selection'
            }

        };

        // Adds easing
        $.extend( $.easing, {
            easeOutQuad: function (x, t, b, c, d) {
                return -c *(t/=d)*(t-2) + b;
            }
        });


    })( jQuery, window , document );

    // Adds easing
    $.extend( $.easing, {
        easeInOutQuint: function (x, t, b, c, d) {
            if ((t/=d/2) < 1) return c/2*t*t*t*t*t + b;
            return c/2*((t-=2)*t*t*t*t + 2) + b;
        }
    });

})( jQuery, window , document );


/*
 * # Semantic - Modal
 * http://github.com/semantic-org/semantic-ui/
 *
 *
 * Copyright 2013 Contributors
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */

;(function ( $, window, document, undefined ) {

    $.fn.modal = function(parameters) {
        var
        $allModules = $(this),
        $window     = $(window),
        $document   = $(document),
        $body       = $('body'),

        time            = new Date().getTime(),
        performance     = [],

        query           = arguments[0],
        methodInvoked   = (typeof query == 'string'),
        queryArguments  = [].slice.call(arguments, 1),

        requestAnimationFrame = window.requestAnimationFrame
        || window.mozRequestAnimationFrame
        || window.webkitRequestAnimationFrame
        || window.msRequestAnimationFrame
        || function(callback) { setTimeout(callback, 0); },

        returnedValue
        ;


        $allModules
        .each(function() {
            var
            settings    = ( $.isPlainObject(parameters) )
            ? $.extend(true, {}, $.fn.modal.settings, parameters)
            : $.extend({}, $.fn.modal.settings),

            selector        = settings.selector,
            className       = settings.className,
            namespace       = settings.namespace,
            error           = settings.error,

            eventNamespace  = '.' + namespace,
            moduleNamespace = 'module-' + namespace,
            moduleSelector  = $allModules.selector || '',

            $module      = $(this),
            $context     = $(settings.context),
            $close       = $module.find(selector.close),

            $allModals,
            $otherModals,
            $focusedElement,
            $dimmable,
            $dimmer,

            element      = this,
            instance     = $module.data(moduleNamespace),
            module
            ;

            module  = {

                initialize: function() {
                    module.verbose('Initializing dimmer', $context);

                    if($.fn.dimmer === undefined) {
                        module.error(error.dimmer);
                        return;
                    }
                    $dimmable = $context
                    .dimmer({
                        closable : false,
                        useCSS   : true,
                        duration : {
                            show     : settings.duration * 0.9,
                            hide     : settings.duration * 1.1
                        }
                    })
                    ;

                    if(settings.detachable) {
                        $dimmable.dimmer('add content', $module);
                    }

                    $dimmer = $dimmable
                    .dimmer('get dimmer')
                    ;

                    module.refreshSelectors();

                    module.verbose('Attaching close events', $close);
                    $close
                    .on('click' + eventNamespace, module.event.close)
                    ;
                    $window
                    .on('resize' + eventNamespace, module.event.resize)
                    ;
                    module.instantiate();
                },

                instantiate: function() {
                    module.verbose('Storing instance of modal');
                    instance = module;
                    $module
                    .data(moduleNamespace, instance)
                    ;
                },

                destroy: function() {
                    module.verbose('Destroying previous modal');
                    $module
                    .removeData(moduleNamespace)
                    .off(eventNamespace)
                    ;
                    $close
                    .off(eventNamespace)
                    ;
                    $context
                    .dimmer('destroy')
                    ;
                },

                refresh: function() {
                    module.remove.scrolling();
                    module.cacheSizes();
                    module.set.screenHeight();
                    module.set.type();
                    module.set.position();
                },

                refreshSelectors: function() {
                    $otherModals = $module.siblings(selector.modal);
                    $allModals   = $otherModals.add($module);
                },

                attachEvents: function(selector, event) {
                    var
                    $toggle = $(selector)
                    ;
                    event = $.isFunction(module[event])
                    ? module[event]
                    : module.toggle
                    ;
                    if($toggle.size() > 0) {
                        module.debug('Attaching modal events to element', selector, event);
                        $toggle
                        .off(eventNamespace)
                        .on('click' + eventNamespace, event)
                        ;
                    }
                    else {
                        module.error(error.notFound);
                    }
                },

                event: {
                    close: function() {
                        module.verbose('Closing element pressed');
                        if( $(this).is(selector.approve) ) {
                            if($.proxy(settings.onApprove, element)() !== false) {
                                module.hide();
                            }
                            else {
                                module.verbose('Approve callback returned false cancelling hide');
                            }
                        }
                        else if( $(this).is(selector.deny) ) {
                            if($.proxy(settings.onDeny, element)() !== false) {
                                module.hide();
                            }
                            else {
                                module.verbose('Deny callback returned false cancelling hide');
                            }
                        }
                        else {
                            module.hide();
                        }
                    },
                    click: function(event) {
                        if( $(event.target).closest(selector.modal).size() === 0 ) {
                            module.debug('Dimmer clicked, hiding all modals');
                            if(settings.allowMultiple) {
                                module.hide();
                            }
                            else {
                                module.hideAll();
                            }
                            event.stopImmediatePropagation();
                        }
                    },
                    debounce: function(method, delay) {
                        clearTimeout(module.timer);
                        module.timer = setTimeout(method, delay);
                    },
                    keyboard: function(event) {
                        var
                        keyCode   = event.which,
                        escapeKey = 27
                        ;
                        if(keyCode == escapeKey) {
                            if(settings.closable) {
                                module.debug('Escape key pressed hiding modal');
                                module.hide();
                            }
                            else {
                                module.debug('Escape key pressed, but closable is set to false');
                            }
                            event.preventDefault();
                        }
                    },
                    resize: function() {
                        if( $dimmable.dimmer('is active') ) {
                            requestAnimationFrame(module.refresh);
                        }
                    }
                },

                toggle: function() {
                    if( module.is.active() ) {
                        module.hide();
                    }
                    else {
                        module.show();
                    }
                },

                show: function(callback) {
                    callback = $.isFunction(callback)
                    ? callback
                    : function(){}
                    ;
                    module.showDimmer();
                    module.showModal(callback);
                },

                onlyVisible: function() {
                    module.refreshSelectors();
                    return module.is.active() && $otherModals.filter(':visible').size() === 0;
                },

                othersVisible: function() {
                    module.refreshSelectors();
                    return $otherModals.filter(':visible').size() > 0;
                },

                showModal: function(callback) {
                    if(module.is.active()) {
                        module.debug('Modal is already visible');
                        return;
                    }

                    callback = $.isFunction(callback)
                    ? callback
                    : function(){}
                    ;

                    module.save.focus();
                    module.add.keyboardShortcuts();

                    if(module.cache === undefined) {
                        module.cacheSizes();
                    }
                    module.set.scrollTop();
                    module.set.position();
                    module.set.screenHeight();
                    module.set.type();

                    if(module.othersVisible()  && !settings.allowMultiple) {
                        module.debug('Other modals visible, queueing show animation');
                        module.hideOthers(module.showModal);
                    }
                    else {
                        $.proxy(settings.onShow, element)();

                        var transitionCallback = function() {
                            module.set.active();
                            $.proxy(settings.onVisible, element)();
                            callback();
                        };

                        if(settings.transition && $.fn.transition !== undefined && $module.transition('is supported')) {
                            module.debug('Showing modal with css animations');
                            $module
                            .transition(settings.transition + ' in', settings.duration, transitionCallback)
                            ;
                        }
                        else {
                            module.debug('Showing modal with javascript');
                            $module
                            .fadeIn(settings.duration, settings.easing, transitionCallback)
                            ;
                        }
                    }
                },

                showDimmer: function() {
                    if( !$dimmable.dimmer('is active') ) {
                        module.debug('Showing dimmer');
                        $dimmable.dimmer('show');
                    }
                    else {
                        module.debug('Dimmer is already visible');
                    }
                },

                hide: function(callback) {
                    callback = $.isFunction(callback)
                    ? callback
                    : function(){}
                    ;
                    module.refreshSelectors();
                    if(module.onlyVisible()) {
                        module.hideDimmer();
                    }
                    module.hideModal(callback);
                    window.scrollTo(null, module.cache.scroll);
                },

                hideDimmer: function() {
                    if( !module.is.active() ) {
                        module.debug('Dimmer is already hidden');
                        return;
                    }
                    module.debug('Hiding dimmer');
                    if(settings.closable) {
                        $dimmer
                        .off('click' + eventNamespace)
                        ;
                    }
                    $dimmable.dimmer('hide', function() {
                        if(settings.transition && $.fn.transition !== undefined && $module.transition('is supported')) {
                            $module
                            .transition('reset')
                            ;
                            module.remove.screenHeight();
                        }
                        module.remove.active();
                    });
                },

                hideModal: function(callback) {
                    if(!module.is.active()) {
                        module.debug('Modal is already hidden');
                        return;
                    }

                    callback = $.isFunction(callback)
                    ? callback
                    : function(){}
                    ;

                    module.restore.focus();
                    module.remove.keyboardShortcuts();

                    $.proxy(settings.onHide, element)();

                    var transitionCallback = function() {
                        module.remove.active();
                        $.proxy(settings.onHidden, element)();
                        callback();
                    };

                    if(settings.transition && $.fn.transition !== undefined && $module.transition('is supported')) {
                        module.debug('Hiding modal with css animations');
                        $module
                        .transition(settings.transition + ' out', settings.duration, transitionCallback)
                        ;
                    }
                    else {
                        module.debug('Hiding modal with javascript');
                        $module
                        .fadeOut(settings.duration, settings.easing, transitionCallback)
                        ;
                    }
                },

                hideAll: function(callback) {
                    callback = $.isFunction(callback)
                    ? callback
                    : function(){}
                    ;
                    if( $module.is(':visible') || module.othersVisible() ) {
                        module.debug('Hiding all visible modals');
                        module.hideDimmer();
                        $allModals
                        .filter(':visible')
                        .modal('hide modal', callback)
                        ;
                    }
                },

                hideOthers: function(callback) {
                    callback = $.isFunction(callback)
                    ? callback
                    : function(){}
                    ;
                    if( module.othersVisible() ) {
                        module.debug('Hiding other modals');
                        $otherModals
                        .filter(':visible')
                        .modal('hide modal', callback)
                        ;
                    }
                },

                add: {
                    keyboardShortcuts: function() {
                        module.verbose('Adding keyboard shortcuts');
                        $document
                        .on('keyup' + eventNamespace, module.event.keyboard)
                        ;
                    }
                },

                save: {
                    focus: function() {
                        $focusedElement = $(document.activeElement).blur();
                    }
                },

                restore: {
                    focus: function() {
                        if($focusedElement && $focusedElement.size() > 0) {
                            $focusedElement.focus();
                        }
                    }
                },

                remove: {
                    active: function() {
                        $module.removeClass(className.active);
                    },
                    screenHeight: function() {
                        if(module.cache.height > module.cache.pageHeight) {
                            module.debug('Removing page height');
                            $body
                            .css('height', '')
                            ;
                        }
                    },
                    keyboardShortcuts: function() {
                        module.verbose('Removing keyboard shortcuts');
                        $document
                        .off('keyup' + eventNamespace)
                        ;
                    },
                    scrolling: function() {
                        $dimmable.removeClass(className.scrolling);
                        $module.removeClass(className.scrolling);
                    }
                },

                cacheSizes: function() {
                    module.cache = {
                        scroll        : window.scrollY,
                        pageHeight    : $body.outerHeight(),
                        height        : $module.outerHeight() + settings.offset,
                        contextHeight : (settings.context == 'body')
                        ? $(window).height()
                        : $dimmable.height()
                    };
                    module.debug('Caching modal and container sizes', module.cache);
                },

                can: {
                    fit: function() {
                        return (module.cache.height < module.cache.contextHeight);
                    }
                },

                is: {
                    active: function() {
                        return $module.hasClass(className.active);
                    },
                    modernBrowser: function() {
                        // appName for IE11 reports 'Netscape' can no longer use
                        return !(window.ActiveXObject || "ActiveXObject" in window);
                    }
                },

                set: {
                    // scrool page to top before modal opens
                    scrollTop: function(){
                        window.scrollTo(null, 0);

                    },
                    screenHeight: function() {
                        if(module.cache.height > module.cache.pageHeight) {
                            module.debug('Modal is taller than page content, resizing page height');
                            $body
                            .css('height', module.cache.height + settings.padding)
                            ;
                        }
                    },
                    active: function() {
                        $module.addClass(className.active);

                        if(settings.closable) {
                            $dimmer
                            .off('click' + eventNamespace)
                            .on('click' + eventNamespace, module.event.click)
                            ;
                        }

                        if(settings.autofocus) {
                            var $inputs    = $module.find(':input:visible');
                            var $autofocus = $inputs.filter('[autofocus]');
                            var $input     = $autofocus.length ? $autofocus : $inputs;

                            $input.first().focus();
                        }
                    },
                    scrolling: function() {
                        $dimmable.addClass(className.scrolling);
                        $module.addClass(className.scrolling);
                    },
                    type: function() {
                        if(module.can.fit()) {
                            module.verbose('Modal fits on screen');
                            module.remove.scrolling();
                        }
                        else {
                            module.verbose('Modal cannot fit on screen setting to scrolling');
                            module.set.scrolling();
                        }
                    },
                    position: function() {
                        module.verbose('Centering modal on page', module.cache);
                        $module
                        .css({
                            marginTop : '1em',
                            top       : 0 
                        })
                        ;
                        /*
                        if(module.can.fit()) {
                            $module
                            .css({
                                top: '',
                                marginTop: -(module.cache.height / 2)
                            })
                            ;
                        }
                        else {
                            $module
                            .css({
                                marginTop : '1em',
                                top       : $document.scrollTop()
                            })
                            ;
                        }
                        */
                    }
                },

                setting: function(name, value) {
                    module.debug('Changing setting', name, value);
                    if( $.isPlainObject(name) ) {
                        $.extend(true, settings, name);
                    }
                    else if(value !== undefined) {
                        settings[name] = value;
                    }
                    else {
                        return settings[name];
                    }
                },
                internal: function(name, value) {
                    if( $.isPlainObject(name) ) {
                        $.extend(true, module, name);
                    }
                    else if(value !== undefined) {
                        module[name] = value;
                    }
                    else {
                        return module[name];
                    }
                },
                debug: function() {
                    if(settings.debug) {
                        if(settings.performance) {
                            module.performance.log(arguments);
                        }
                        else {
                            module.debug = Function.prototype.bind.call(console.info, console, settings.name + ':');
                            module.debug.apply(console, arguments);
                        }
                    }
                },
                verbose: function() {
                    if(settings.verbose && settings.debug) {
                        if(settings.performance) {
                            module.performance.log(arguments);
                        }
                        else {
                            module.verbose = Function.prototype.bind.call(console.info, console, settings.name + ':');
                            module.verbose.apply(console, arguments);
                        }
                    }
                },
                error: function() {
                    module.error = Function.prototype.bind.call(console.error, console, settings.name + ':');
                    module.error.apply(console, arguments);
                },
                performance: {
                    log: function(message) {
                        var
                        currentTime,
                        executionTime,
                        previousTime
                        ;
                        if(settings.performance) {
                            currentTime   = new Date().getTime();
                            previousTime  = time || currentTime;
                            executionTime = currentTime - previousTime;
                            time          = currentTime;
                            performance.push({
                                'Element'        : element,
                                'Name'           : message[0],
                                'Arguments'      : [].slice.call(message, 1) || '',
                                'Execution Time' : executionTime
                            });
                        }
                        clearTimeout(module.performance.timer);
                        module.performance.timer = setTimeout(module.performance.display, 100);
                    },
                    display: function() {
                        var
                        title = settings.name + ':',
                        totalTime = 0
                        ;
                        time = false;
                        clearTimeout(module.performance.timer);
                        $.each(performance, function(index, data) {
                            totalTime += data['Execution Time'];
                        });
                        title += ' ' + totalTime + 'ms';
                        if(moduleSelector) {
                            title += ' \'' + moduleSelector + '\'';
                        }
                        if( (console.group !== undefined || console.table !== undefined) && performance.length > 0) {
                            console.groupCollapsed(title);
                            if(console.table) {
                                console.table(performance);
                            }
                            else {
                                $.each(performance, function(index, data) {
                                    console.log(data['Name'] + ': ' + data['Execution Time']+'ms');
                                });
                            }
                            console.groupEnd();
                        }
                        performance = [];
                    }
                },
                invoke: function(query, passedArguments, context) {
                    var
                    object = instance,
                    maxDepth,
                    found,
                    response
                    ;
                    passedArguments = passedArguments || queryArguments;
                    context         = element         || context;
                    if(typeof query == 'string' && object !== undefined) {
                        query    = query.split(/[\. ]/);
                        maxDepth = query.length - 1;
                        $.each(query, function(depth, value) {
                            var camelCaseValue = (depth != maxDepth)
                            ? value + query[depth + 1].charAt(0).toUpperCase() + query[depth + 1].slice(1)
                            : query
                            ;
                            if( $.isPlainObject( object[camelCaseValue] ) && (depth != maxDepth) ) {
                                object = object[camelCaseValue];
                            }
                            else if( object[camelCaseValue] !== undefined ) {
                                found = object[camelCaseValue];
                                return false;
                            }
                            else if( $.isPlainObject( object[value] ) && (depth != maxDepth) ) {
                                object = object[value];
                            }
                            else if( object[value] !== undefined ) {
                                found = object[value];
                                return false;
                            }
                            else {
                                return false;
                            }
                        });
                    }
                    if ( $.isFunction( found ) ) {
                        response = found.apply(context, passedArguments);
                    }
                    else if(found !== undefined) {
                        response = found;
                    }
                    if($.isArray(returnedValue)) {
                        returnedValue.push(response);
                    }
                    else if(returnedValue !== undefined) {
                        returnedValue = [returnedValue, response];
                    }
                    else if(response !== undefined) {
                        returnedValue = response;
                    }
                    return found;
                }
            };

            if(methodInvoked) {
                if(instance === undefined) {
                    module.initialize();
                }
                module.invoke(query);
            }
            else {
                if(instance !== undefined) {
                    module.destroy();
                }
                module.initialize();
            }
        })
        ;

        return (returnedValue !== undefined)
        ? returnedValue
        : this
        ;
    };

    $.fn.modal.settings = {

        name          : 'Modal',
        namespace     : 'modal',

        debug         : false,
        verbose       : true,
        performance   : true,

        allowMultiple : true,
        detachable    : true,
        closable      : true,
        autofocus     : true,
        context       : 'body',

        duration      : 500,
        easing        : 'easeOutQuad',
        offset        : 0,
        transition    : 'scale',

        padding       : 30,

        onShow        : function(){},
        onHide        : function(){},

        onVisible     : function(){},
        onHidden      : function(){},

        onApprove     : function(){ return true; },
        onDeny        : function(){ return true; },

        selector    : {
            close    : '.close, .actions .button',
            approve  : '.actions .positive, .actions .approve, .actions .ok',
            deny     : '.actions .negative, .actions .deny, .actions .cancel',
            modal    : '.ui.modal'
        },
        error : {
            dimmer    : 'UI Dimmer, a required component is not included in this page',
            method    : 'The method you called is not defined.'
        },
        className : {
            active    : 'active',
            scrolling : 'scrolling'
        }
    };

    // Adds easing
    $.extend( $.easing, {
        easeOutQuad: function (x, t, b, c, d) {
            return -c *(t/=d)*(t-2) + b;
        }
    });

})( jQuery, window , document );


/*
 * # Semantic - Dimmer
 * http://github.com/jlukic/semantic-ui/
 *
 *
 * Copyright 2013 Contributors
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */

;(function ( $, window, document, undefined ) {

    $.fn.dimmer = function(parameters) {
        var
        $allModules     = $(this),

        time            = new Date().getTime(),
        performance     = [],

        query           = arguments[0],
        methodInvoked   = (typeof query == 'string'),
        queryArguments  = [].slice.call(arguments, 1),

        returnedValue
        ;

        $allModules
        .each(function() {
            var
            settings        = ( $.isPlainObject(parameters) )
            ? $.extend(true, {}, $.fn.dimmer.settings, parameters)
            : $.extend({}, $.fn.dimmer.settings),

            selector        = settings.selector,
            namespace       = settings.namespace,
            className       = settings.className,
            error           = settings.error,

            eventNamespace  = '.' + namespace,
            moduleNamespace = 'module-' + namespace,
            moduleSelector  = $allModules.selector || '',

            clickEvent      = ('ontouchstart' in document.documentElement)
            ? 'touchstart'
            : 'click',

            $module = $(this),
            $dimmer,
            $dimmable,

            element   = this,
            instance  = $module.data(moduleNamespace),
            module
            ;

            module = {

                preinitialize: function() {
                    if( module.is.dimmer() ) {
                        $dimmable = $module.parent();
                        $dimmer   = $module;
                    }
                    else {
                        $dimmable = $module;
                        if( module.has.dimmer() ) {
                            $dimmer = $dimmable.children(selector.dimmer).first();
                        }
                        else {
                            $dimmer = module.create();
                        }
                    }
                },

                initialize: function() {
                    module.debug('Initializing dimmer', settings);
                    if(settings.on == 'hover') {
                        $dimmable
                        .on('mouseenter' + eventNamespace, module.show)
                        .on('mouseleave' + eventNamespace, module.hide)
                        ;
                    }
                    else if(settings.on == 'click') {
                        $dimmable
                        .on(clickEvent + eventNamespace, module.toggle)
                        ;
                    }

                    if( module.is.page() ) {
                        module.debug('Setting as a page dimmer', $dimmable);
                        module.set.pageDimmer();
                    }

                    if(settings.closable) {
                        module.verbose('Adding dimmer close event', $dimmer);
                        $dimmer
                        .on(clickEvent + eventNamespace, module.event.click)
                        ;
                    }
                    module.set.dimmable();
                    module.instantiate();
                },

                instantiate: function() {
                    module.verbose('Storing instance of module', module);
                    instance = module;
                    $module
                    .data(moduleNamespace, instance)
                    ;
                },

                destroy: function() {
                    module.verbose('Destroying previous module', $dimmer);
                    $module
                    .removeData(moduleNamespace)
                    ;
                    $dimmable
                    .off(eventNamespace)
                    ;
                    $dimmer
                    .off(eventNamespace)
                    ;
                },

                event: {

                    click: function(event) {
                        module.verbose('Determining if event occured on dimmer', event);
                        if( $dimmer.find(event.target).size() === 0 || $(event.target).is(selector.content) ) {
                            module.hide();
                            event.stopImmediatePropagation();
                        }
                    }

                },

                addContent: function(element) {
                    var
                    $content = $(element)
                    ;
                    module.debug('Add content to dimmer', $content);
                    if($content.parent()[0] !== $dimmer[0]) {
                        $content.detach().appendTo($dimmer);
                    }
                },

                create: function() {
                    return $( settings.template.dimmer() ).appendTo($dimmable);
                },

                animate: {
                    show: function(callback) {
                        callback = $.isFunction(callback)
                        ? callback
                        : function(){}
                        ;
                        module.set.dimmed();
                        if(settings.on != 'hover' && settings.useCSS && $.fn.transition !== undefined && $dimmer.transition('is supported')) {
                            $dimmer
                            .transition({
                                animation : settings.transition + ' in',
                                queue     : true,
                                duration  : module.get.duration(),
                                complete  : function() {
                                    module.set.active();
                                    callback();
                                }
                            })
                            ;
                        }
                        else {
                            module.verbose('Showing dimmer animation with javascript');
                            $dimmer
                            .stop()
                            .css({
                                opacity : 0,
                                width   : '100%',
                                height  : '100%'
                            })
                            .fadeTo(module.get.duration(), 1, function() {
                                $dimmer.removeAttr('style');
                                module.set.active();
                                callback();
                            })
                            ;
                        }
                    },
                    hide: function(callback) {
                        callback = $.isFunction(callback)
                        ? callback
                        : function(){}
                        ;
                        if(settings.on != 'hover' && settings.useCSS && $.fn.transition !== undefined && $dimmer.transition('is supported')) {
                            module.verbose('Hiding dimmer with css');
                            $dimmer
                            .transition({
                                animation : settings.transition + ' out',
                                duration  : module.get.duration(),
                                queue     : true,
                                complete  : function() {
                                    module.remove.dimmed();
                                    module.remove.active();
                                    callback();
                                }
                            })
                            ;
                        }
                        else {
                            module.verbose('Hiding dimmer with javascript');
                            $dimmer
                            .stop()
                            .fadeOut(module.get.duration(), function() {
                                $dimmer.removeAttr('style');
                                module.remove.dimmed();
                                module.remove.active();
                                callback();
                            })
                            ;
                        }
                    }
                },

                get: {
                    dimmer: function() {
                        return $dimmer;
                    },
                    duration: function() {
                        if(typeof settings.duration == 'object') {
                            if( module.is.active() ) {
                                return settings.duration.hide;
                            }
                            else {
                                return settings.duration.show;
                            }
                        }
                        return settings.duration;
                    }
                },

                has: {
                    dimmer: function() {
                        return ( $module.children(selector.dimmer).size() > 0 );
                    }
                },

                is: {
                    active: function() {
                        return $dimmer.hasClass(className.active);
                    },
                    animating: function() {
                        return ( $dimmer.is(':animated') || $dimmer.hasClass(className.transition) );
                    },
                    dimmer: function() {
                        return $module.is(selector.dimmer);
                    },
                    dimmable: function() {
                        return $module.is(selector.dimmable);
                    },
                    dimmed: function() {
                        return $dimmable.hasClass(className.dimmed);
                    },
                    disabled: function() {
                        return $dimmable.hasClass(className.disabled);
                    },
                    enabled: function() {
                        return !module.is.disabled();
                    },
                    page: function () {
                        return $dimmable.is('body');
                    },
                    pageDimmer: function() {
                        return $dimmer.hasClass(className.pageDimmer);
                    }
                },

                can: {
                    show: function() {
                        return !$dimmer.hasClass(className.disabled);
                    }
                },

                set: {
                    active: function() {
                        module.set.dimmed();
                        $dimmer
                        .removeClass(className.transition)
                        .addClass(className.active)
                        ;
                    },
                    dimmable: function() {
                        $dimmable.addClass(className.dimmable);
                    },
                    dimmed: function() {
                        $dimmable.addClass(className.dimmed);
                    },
                    pageDimmer: function() {
                        $dimmer.addClass(className.pageDimmer);
                    },
                    disabled: function() {
                        $dimmer.addClass(className.disabled);
                    }
                },

                remove: {
                    active: function() {
                        $dimmer
                        .removeClass(className.transition)
                        .removeClass(className.active)
                        ;
                    },
                    dimmed: function() {
                        $dimmable.removeClass(className.dimmed);
                    },
                    disabled: function() {
                        $dimmer.removeClass(className.disabled);
                    }
                },

                show: function(callback) {
                    callback = $.isFunction(callback)
                    ? callback
                    : function(){}
                    ;
                    module.debug('Showing dimmer', $dimmer, settings);
                    if( !module.is.active() && module.is.enabled() ) {
                        module.animate.show(callback);
                        $.proxy(settings.onShow, element)();
                        $.proxy(settings.onChange, element)();
                    }
                    else {
                        module.debug('Dimmer is already shown or disabled');
                    }
                },

                hide: function(callback) {
                    callback = $.isFunction(callback)
                    ? callback
                    : function(){}
                    ;
                    if( module.is.active() || module.is.animating() ) {
                        module.debug('Hiding dimmer', $dimmer);
                        module.animate.hide(callback);
                        $.proxy(settings.onHide, element)();
                        $.proxy(settings.onChange, element)();
                    }
                    else {
                        module.debug('Dimmer is not visible');
                    }
                },

                toggle: function() {
                    module.verbose('Toggling dimmer visibility', $dimmer);
                    if( !module.is.dimmed() ) {
                        module.show();
                    }
                    else {
                        module.hide();
                    }
                },

                setting: function(name, value) {
                    if( $.isPlainObject(name) ) {
                        $.extend(true, settings, name);
                    }
                    else if(value !== undefined) {
                        settings[name] = value;
                    }
                    else {
                        return settings[name];
                    }
                },
                internal: function(name, value) {
                    if( $.isPlainObject(name) ) {
                        $.extend(true, module, name);
                    }
                    else if(value !== undefined) {
                        module[name] = value;
                    }
                    else {
                        return module[name];
                    }
                },
                debug: function() {
                    if(settings.debug) {
                        if(settings.performance) {
                            module.performance.log(arguments);
                        }
                        else {
                            module.debug = Function.prototype.bind.call(console.info, console, settings.name + ':');
                            module.debug.apply(console, arguments);
                        }
                    }
                },
                verbose: function() {
                    if(settings.verbose && settings.debug) {
                        if(settings.performance) {
                            module.performance.log(arguments);
                        }
                        else {
                            module.verbose = Function.prototype.bind.call(console.info, console, settings.name + ':');
                            module.verbose.apply(console, arguments);
                        }
                    }
                },
                error: function() {
                    module.error = Function.prototype.bind.call(console.error, console, settings.name + ':');
                    module.error.apply(console, arguments);
                },
                performance: {
                    log: function(message) {
                        var
                        currentTime,
                        executionTime,
                        previousTime
                        ;
                        if(settings.performance) {
                            currentTime   = new Date().getTime();
                            previousTime  = time || currentTime;
                            executionTime = currentTime - previousTime;
                            time          = currentTime;
                            performance.push({
                                'Element'        : element,
                                'Name'           : message[0],
                                'Arguments'      : [].slice.call(message, 1) || '',
                                'Execution Time' : executionTime
                            });
                        }
                        clearTimeout(module.performance.timer);
                        module.performance.timer = setTimeout(module.performance.display, 100);
                    },
                    display: function() {
                        var
                        title = settings.name + ':',
                        totalTime = 0
                        ;
                        time = false;
                        clearTimeout(module.performance.timer);
                        $.each(performance, function(index, data) {
                            totalTime += data['Execution Time'];
                        });
                        title += ' ' + totalTime + 'ms';
                        if(moduleSelector) {
                            title += ' \'' + moduleSelector + '\'';
                        }
                        if($allModules.size() > 1) {
                            title += ' ' + '(' + $allModules.size() + ')';
                        }
                        if( (console.group !== undefined || console.table !== undefined) && performance.length > 0) {
                            console.groupCollapsed(title);
                            if(console.table) {
                                console.table(performance);
                            }
                            else {
                                $.each(performance, function(index, data) {
                                    console.log(data['Name'] + ': ' + data['Execution Time']+'ms');
                                });
                            }
                            console.groupEnd();
                        }
                        performance = [];
                    }
                },
                invoke: function(query, passedArguments, context) {
                    var
                    object = instance,
                    maxDepth,
                    found,
                    response
                    ;
                    passedArguments = passedArguments || queryArguments;
                    context         = element         || context;
                    if(typeof query == 'string' && object !== undefined) {
                        query    = query.split(/[\. ]/);
                        maxDepth = query.length - 1;
                        $.each(query, function(depth, value) {
                            var camelCaseValue = (depth != maxDepth)
                            ? value + query[depth + 1].charAt(0).toUpperCase() + query[depth + 1].slice(1)
                            : query
                            ;
                            if( $.isPlainObject( object[camelCaseValue] ) && (depth != maxDepth) ) {
                                object = object[camelCaseValue];
                            }
                            else if( object[camelCaseValue] !== undefined ) {
                                found = object[camelCaseValue];
                                return false;
                            }
                            else if( $.isPlainObject( object[value] ) && (depth != maxDepth) ) {
                                object = object[value];
                            }
                            else if( object[value] !== undefined ) {
                                found = object[value];
                                return false;
                            }
                            else {
                                return false;
                            }
                        });
                    }
                    if ( $.isFunction( found ) ) {
                        response = found.apply(context, passedArguments);
                    }
                    else if(found !== undefined) {
                        response = found;
                    }
                    if($.isArray(returnedValue)) {
                        returnedValue.push(response);
                    }
                    else if(returnedValue !== undefined) {
                        returnedValue = [returnedValue, response];
                    }
                    else if(response !== undefined) {
                        returnedValue = response;
                    }
                    return found;
                }
            };

            module.preinitialize();

            if(methodInvoked) {
                if(instance === undefined) {
                    module.initialize();
                }
                module.invoke(query);
            }
            else {
                if(instance !== undefined) {
                    module.destroy();
                }
                module.initialize();
            }
        })
        ;

        return (returnedValue !== undefined)
        ? returnedValue
        : this
        ;
    };

    $.fn.dimmer.settings = {

        name        : 'Dimmer',
        namespace   : 'dimmer',

        debug       : false,
        verbose     : true,
        performance : true,

        transition  : 'fade',
        useCSS      : true,
        on          : false,
        closable    : true,

        duration    : {
            show : 500,
            hide : 500
        },

        onChange    : function(){},
        onShow      : function(){},
        onHide      : function(){},

        error   : {
            method   : 'The method you called is not defined.'
        },

        selector: {
            dimmable : '.ui.dimmable',
            dimmer   : '.ui.dimmer',
            content  : '.ui.dimmer > .content, .ui.dimmer > .content > .center'
        },

        template: {
            dimmer: function() {
                return $('<div />').attr('class', 'ui dimmer');
            }
        },

        className : {
            active     : 'active',
            dimmable   : 'ui dimmable',
            dimmed     : 'dimmed',
            disabled   : 'disabled',
            pageDimmer : 'page',
            hide       : 'hide',
            show       : 'show',
            transition : 'transition'
        }

    };

})( jQuery, window , document );


/*
 * # Semantic - Transition
 * http://github.com/jlukic/semantic-ui/
 *
 *
 * Copyright 2013 Contributors
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */

;(function ( $, window, document, undefined ) {

    $.fn.transition = function() {
        var
        $allModules     = $(this),
        moduleSelector  = $allModules.selector || '',

        time            = new Date().getTime(),
        performance     = [],

        moduleArguments = arguments,
        query           = moduleArguments[0],
        queryArguments  = [].slice.call(arguments, 1),
        methodInvoked   = (typeof query === 'string'),

        requestAnimationFrame = window.requestAnimationFrame
        || window.mozRequestAnimationFrame
        || window.webkitRequestAnimationFrame
        || window.msRequestAnimationFrame
        || function(callback) { setTimeout(callback, 0); },

        returnedValue
        ;
        $allModules
        .each(function() {
            var
            $module  = $(this),
            element  = this,

            // set at run time
            settings,
            instance,

            error,
            className,
            metadata,
            animationEnd,
            animationName,

            namespace,
            moduleNamespace,
            module
            ;

            module = {

                initialize: function() {
                    // get settings
                    settings        = module.get.settings.apply(element, moduleArguments);
                    module.verbose('Converted arguments into settings object', settings);

                    // set shortcuts
                    error           = settings.error;
                    className       = settings.className;
                    namespace       = settings.namespace;
                    metadata        = settings.metadata;
                    moduleNamespace = 'module-' + namespace;

                    animationEnd    = module.get.animationEvent();
                    animationName   = module.get.animationName();

                    instance        = $module.data(moduleNamespace) || module;

                    if(methodInvoked) {
                        methodInvoked = module.invoke(query);
                    }
                    // no internal method was found matching query or query not made
                    if(methodInvoked === false) {
                        module.animate();
                    }
                    module.instantiate();
                },

                instantiate: function() {
                    module.verbose('Storing instance of module', module);
                    $module
                    .data(moduleNamespace, instance)
                    ;
                },

                destroy: function() {
                    module.verbose('Destroying previous module for', element);
                    $module
                    .removeData(moduleNamespace)
                    ;
                },

                refresh: function() {
                    module.verbose('Refreshing display type on next animation');
                    delete instance.displayType;
                },

                forceRepaint: function() {
                    module.verbose('Forcing element repaint');
                    var
                    $parentElement = $module.parent(),
                    $nextElement = $module.next()
                    ;
                    if($nextElement.size() === 0) {
                        $module.detach().appendTo($parentElement);
                    }
                    else {
                        $module.detach().insertBefore($nextElement);
                    }
                },

                repaint: function() {
                    module.verbose('Repainting element');
                    var
                    fakeAssignment = element.offsetWidth
                    ;
                },

                animate: function(overrideSettings) {
                    settings = overrideSettings || settings;
                    if(!module.is.supported()) {
                        module.error(error.support);
                        return false;
                    }
                    module.debug('Preparing animation', settings.animation);
                    if(module.is.animating() && settings.queue) {
                        if(!settings.allowRepeats && module.has.direction() && module.is.occuring() && instance.queuing !== true) {
                            module.error(error.repeated);
                        }
                        else {
                            module.queue(settings.animation);
                        }
                        return false;
                    }
                    if(module.can.animate) {
                        module.set.animating(settings.animation);
                    }
                    else {
                        module.error(error.noAnimation, settings.animation);
                    }
                },

                reset: function() {
                    module.debug('Resetting animation to beginning conditions');
                    $module.off(animationEnd);
                    module.restore.conditions();
                    module.hide();
                    module.remove.animating();
                },

                queue: function(animation) {
                    module.debug('Queueing animation of', animation);
                    instance.queuing = true;
                    $module
                    .one(animationEnd, function() {
                        instance.queuing = false;
                        module.repaint();
                        module.animate.apply(this, settings);
                    })
                    ;
                },

                complete: function () {
                    module.verbose('CSS animation complete', settings.animation);
                    if(!module.is.looping()) {
                        if( module.is.outward() ) {
                            module.verbose('Animation is outward, hiding element');
                            module.restore.conditions();
                            module.remove.display();
                            module.hide();
                            $.proxy(settings.onHide, this)();
                        }
                        else if( module.is.inward() ) {
                            module.verbose('Animation is outward, showing element');
                            module.restore.conditions();
                            module.show();
                            $.proxy(settings.onShow, this)();
                        }
                        else {
                            module.restore.conditions();
                        }
                        module.remove.duration();
                        module.remove.animating();
                    }
                    $.proxy(settings.complete, this)();
                },

                has: {
                    direction: function(animation) {
                        animation = animation || settings.animation;
                        if( animation.search(className.inward) !== -1 || animation.search(className.outward) !== -1) {
                            module.debug('Direction already set in animation');
                            return true;
                        }
                        return false;
                    }
                },

                set: {

                    animating: function(animation) {
                        animation = animation || settings.animation;
                        module.save.conditions();
                        if(module.can.transition() && !module.has.direction()) {
                            module.set.direction();
                        }
                        module.remove.hidden();
                        module.set.display();
                        $module
                        .addClass(className.animating)
                        .addClass(className.transition)
                        .addClass(animation)
                        .one(animationEnd, module.complete)
                        ;
                        module.set.duration(settings.duration);
                        module.debug('Starting tween', settings.animation, $module.attr('class'));
                    },

                    display: function() {
                        var
                        displayType = module.get.displayType()
                        ;
                        if(displayType !== 'block' && displayType !== 'none') {
                            module.verbose('Setting final visibility to', displayType);
                            $module
                            .css({
                                display: displayType
                            })
                            ;
                        }
                    },

                    direction: function() {
                        if($module.is(':visible')) {
                            module.debug('Automatically determining the direction of animation', 'Outward');
                            $module
                            .removeClass(className.inward)
                            .addClass(className.outward)
                            ;
                        }
                        else {
                            module.debug('Automatically determining the direction of animation', 'Inward');
                            $module
                            .removeClass(className.outward)
                            .addClass(className.inward)
                            ;
                        }
                    },

                    looping: function() {
                        module.debug('Transition set to loop');
                        $module
                        .addClass(className.looping)
                        ;
                    },

                    duration: function(duration) {
                        duration = duration || settings.duration;
                        duration = (typeof duration == 'number')
                        ? duration + 'ms'
                        : duration
                        ;
                        module.verbose('Setting animation duration', duration);
                        $module
                        .css({
                            '-webkit-animation-duration': duration,
                            '-moz-animation-duration': duration,
                            '-ms-animation-duration': duration,
                            '-o-animation-duration': duration,
                            'animation-duration': duration
                        })
                        ;
                    },

                    hidden: function() {
                        $module
                        .addClass(className.transition)
                        .addClass(className.hidden)
                        ;
                    },

                    visible: function() {
                        $module
                        .addClass(className.transition)
                        .addClass(className.visible)
                        ;
                    }
                },

                save: {
                    displayType: function(displayType) {
                        instance.displayType = displayType;
                    },
                    transitionExists: function(animation, exists) {
                        $.fn.transition.exists[animation] = exists;
                        module.verbose('Saving existence of transition', animation, exists);
                    },
                    conditions: function() {
                        instance.cache = {
                            className : $module.attr('class'),
                            style     : $module.attr('style')
                        };
                        module.verbose('Saving original attributes', instance.cache);
                    }
                },

                restore: {
                    conditions: function() {
                        if(instance.cache === undefined) {
                            return false;
                        }
                        if(instance.cache.className) {
                            $module.attr('class', instance.cache.className);
                        }
                        else {
                            $module.removeAttr('class');
                        }
                        if(instance.cache.style) {
                            $module.attr('style', instance.cache.style);
                        }
                        else {
                            if(module.get.displayType() === 'block') {
                                $module.removeAttr('style');
                            }
                        }
                        if(module.is.looping()) {
                            module.remove.looping();
                        }
                        module.verbose('Restoring original attributes', instance.cache);
                    }
                },

                remove: {

                    animating: function() {
                        $module.removeClass(className.animating);
                    },

                    display: function() {
                        if(instance.displayType !== undefined) {
                            $module.css('display', '');
                        }
                    },

                    duration: function() {
                        $module
                        .css({
                            '-webkit-animation-duration' : '',
                            '-moz-animation-duration'    : '',
                            '-ms-animation-duration'     : '',
                            '-o-animation-duration'      : '',
                            'animation-duration'         : ''
                        })
                        ;
                    },

                    hidden: function() {
                        $module.removeClass(className.hidden);
                    },

                    visible: function() {
                        $module.removeClass(className.visible);
                    },

                    looping: function() {
                        module.debug('Transitions are no longer looping');
                        $module
                        .removeClass(className.looping)
                        ;
                        module.forceRepaint();
                    }

                },

                get: {

                    settings: function(animation, duration, complete) {
                        // single settings object
                        if(typeof animation == 'object') {
                            return $.extend(true, {}, $.fn.transition.settings, animation);
                        }
                        // all arguments provided
                        else if(typeof complete == 'function') {
                            return $.extend({}, $.fn.transition.settings, {
                                animation : animation,
                                complete  : complete,
                                duration  : duration
                            });
                        }
                        // only duration provided
                        else if(typeof duration == 'string' || typeof duration == 'number') {
                            return $.extend({}, $.fn.transition.settings, {
                                animation : animation,
                                duration  : duration
                            });
                        }
                        // duration is actually settings object
                        else if(typeof duration == 'object') {
                            return $.extend({}, $.fn.transition.settings, duration, {
                                animation : animation
                            });
                        }
                        // duration is actually callback
                        else if(typeof duration == 'function') {
                            return $.extend({}, $.fn.transition.settings, {
                                animation : animation,
                                complete  : duration
                            });
                        }
                        // only animation provided
                        else {
                            return $.extend({}, $.fn.transition.settings, {
                                animation : animation
                            });
                        }
                        return $.fn.transition.settings;
                    },

                    displayType: function() {
                        if(instance.displayType === undefined) {
                            // create fake element to determine display state
                            module.can.transition();
                        }
                        return instance.displayType;
                    },

                    transitionExists: function(animation) {
                        return $.fn.transition.exists[animation];
                    },

                    animationName: function() {
                        var
                        element     = document.createElement('div'),
                        animations  = {
                            'animation'       :'animationName',
                            'OAnimation'      :'oAnimationName',
                            'MozAnimation'    :'mozAnimationName',
                            'WebkitAnimation' :'webkitAnimationName'
                        },
                        animation
                        ;
                        for(animation in animations){
                            if( element.style[animation] !== undefined ){
                                module.verbose('Determined animation vendor name property', animations[animation]);
                                return animations[animation];
                            }
                        }
                        return false;
                    },

                    animationEvent: function() {
                        var
                        element     = document.createElement('div'),
                        animations  = {
                            'animation'       :'animationend',
                            'OAnimation'      :'oAnimationEnd',
                            'MozAnimation'    :'animationend',
                            'WebkitAnimation' :'webkitAnimationEnd'
                        },
                        animation
                        ;
                        for(animation in animations){
                            if( element.style[animation] !== undefined ){
                                module.verbose('Determined animation vendor end event', animations[animation]);
                                return animations[animation];
                            }
                        }
                        return false;
                    }

                },

                can: {
                    animate: function() {
                        if($module.css(settings.animation) !== 'none') {
                            module.debug('CSS definition found',  $module.css(settings.animation));
                            return true;
                        }
                        else {
                            module.debug('Unable to find css definition', $module.attr('class'));
                            return false;
                        }
                    },
                    transition: function() {
                        var
                        elementClass     = $module.attr('class'),
                        animation        = settings.animation,
                        transitionExists = module.get.transitionExists(settings.animation),
                        $clone,
                        currentAnimation,
                        inAnimation,
                        displayType
                        ;
                        if( transitionExists === undefined || instance.displayType === undefined) {
                            module.verbose('Determining whether animation exists');
                            $clone = $('<div>').addClass( elementClass ).appendTo($('body'));
                            currentAnimation = $clone
                            .removeClass(className.inward)
                            .removeClass(className.outward)
                            .addClass(className.animating)
                            .addClass(className.transition)
                            .addClass(animation)
                            .css(animationName)
                            ;
                            inAnimation = $clone
                            .addClass(className.inward)
                            .css(animationName)
                            ;
                            displayType = $clone
                            .attr('class', elementClass)
                            .show()
                            .css('display')
                            ;
                            module.verbose('Determining final display state', displayType);
                            if(currentAnimation != inAnimation) {
                                module.debug('Transition exists for animation', animation);
                                transitionExists = true;
                            }
                            else {
                                module.debug('Static animation found', animation, displayType);
                                transitionExists = false;
                            }
                            $clone.remove();
                            module.save.displayType(displayType);
                            module.save.transitionExists(animation, transitionExists);
                        }
                        return transitionExists;
                    }
                },

                is: {
                    animating: function() {
                        return $module.hasClass(className.animating);
                    },
                    inward: function() {
                        return $module.hasClass(className.inward);
                    },
                    outward: function() {
                        return $module.hasClass(className.outward);
                    },
                    looping: function() {
                        return $module.hasClass(className.looping);
                    },
                    occuring: function(animation) {
                        animation = animation || settings.animation;
                        return ( $module.hasClass(animation) );
                    },
                    visible: function() {
                        return $module.is(':visible');
                    },
                    supported: function() {
                        return(animationName !== false && animationEnd !== false);
                    }
                },

                hide: function() {
                    module.verbose('Hiding element');
                    module.remove.visible();
                    module.set.hidden();
                    module.repaint();
                },

                show: function(display) {
                    module.verbose('Showing element', display);
                    module.remove.hidden();
                    module.set.visible();
                    module.repaint();
                },

                start: function() {
                    module.verbose('Starting animation');
                    $module.removeClass(className.disabled);
                },

                stop: function() {
                    module.debug('Stopping animation');
                    $module.addClass(className.disabled);
                },

                toggle: function() {
                    module.debug('Toggling play status');
                    $module.toggleClass(className.disabled);
                },

                setting: function(name, value) {
                    if( $.isPlainObject(name) ) {
                        $.extend(true, settings, name);
                    }
                    else if(value !== undefined) {
                        settings[name] = value;
                    }
                    else {
                        return settings[name];
                    }
                },
                internal: function(name, value) {
                    if( $.isPlainObject(name) ) {
                        $.extend(true, module, name);
                    }
                    else if(value !== undefined) {
                        module[name] = value;
                    }
                    else {
                        return module[name];
                    }
                },
                debug: function() {
                    if(settings.debug) {
                        if(settings.performance) {
                            module.performance.log(arguments);
                        }
                        else {
                            module.debug = Function.prototype.bind.call(console.info, console, settings.name + ':');
                            module.debug.apply(console, arguments);
                        }
                    }
                },
                verbose: function() {
                    if(settings.verbose && settings.debug) {
                        if(settings.performance) {
                            module.performance.log(arguments);
                        }
                        else {
                            module.verbose = Function.prototype.bind.call(console.info, console, settings.name + ':');
                            module.verbose.apply(console, arguments);
                        }
                    }
                },
                error: function() {
                    module.error = Function.prototype.bind.call(console.error, console, settings.name + ':');
                    module.error.apply(console, arguments);
                },
                performance: {
                    log: function(message) {
                        var
                        currentTime,
                        executionTime,
                        previousTime
                        ;
                        if(settings.performance) {
                            currentTime   = new Date().getTime();
                            previousTime  = time || currentTime;
                            executionTime = currentTime - previousTime;
                            time          = currentTime;
                            performance.push({
                                'Element'        : element,
                                'Name'           : message[0],
                                'Arguments'      : [].slice.call(message, 1) || '',
                                'Execution Time' : executionTime
                            });
                        }
                        clearTimeout(module.performance.timer);
                        module.performance.timer = setTimeout(module.performance.display, 100);
                    },
                    display: function() {
                        var
                        title = settings.name + ':',
                        totalTime = 0
                        ;
                        time = false;
                        clearTimeout(module.performance.timer);
                        $.each(performance, function(index, data) {
                            totalTime += data['Execution Time'];
                        });
                        title += ' ' + totalTime + 'ms';
                        if(moduleSelector) {
                            title += ' \'' + moduleSelector + '\'';
                        }
                        if($allModules.size() > 1) {
                            title += ' ' + '(' + $allModules.size() + ')';
                        }
                        if( (console.group !== undefined || console.table !== undefined) && performance.length > 0) {
                            console.groupCollapsed(title);
                            if(console.table) {
                                console.table(performance);
                            }
                            else {
                                $.each(performance, function(index, data) {
                                    console.log(data['Name'] + ': ' + data['Execution Time']+'ms');
                                });
                            }
                            console.groupEnd();
                        }
                        performance = [];
                    }
                },
                invoke: function(query, passedArguments, context) {
                    var
                    object = instance,
                    maxDepth,
                    found,
                    response
                    ;
                    passedArguments = passedArguments || queryArguments;
                    context         = element         || context;
                    if(typeof query == 'string' && object !== undefined) {
                        query    = query.split(/[\. ]/);
                        maxDepth = query.length - 1;
                        $.each(query, function(depth, value) {
                            var camelCaseValue = (depth != maxDepth)
                            ? value + query[depth + 1].charAt(0).toUpperCase() + query[depth + 1].slice(1)
                            : query
                            ;
                            if( $.isPlainObject( object[camelCaseValue] ) && (depth != maxDepth) ) {
                                object = object[camelCaseValue];
                            }
                            else if( object[camelCaseValue] !== undefined ) {
                                found = object[camelCaseValue];
                                return false;
                            }
                            else if( $.isPlainObject( object[value] ) && (depth != maxDepth) ) {
                                object = object[value];
                            }
                            else if( object[value] !== undefined ) {
                                found = object[value];
                                return false;
                            }
                            else {
                                return false;
                            }
                        });
                    }
                    if ( $.isFunction( found ) ) {
                        response = found.apply(context, passedArguments);
                    }
                    else if(found !== undefined) {
                        response = found;
                    }
                    if($.isArray(returnedValue)) {
                        returnedValue.push(response);
                    }
                    else if(returnedValue !== undefined) {
                        returnedValue = [returnedValue, response];
                    }
                    else if(response !== undefined) {
                        returnedValue = response;
                    }
                    return found || false;
                }
            };
            module.initialize();
        })
        ;
        return (returnedValue !== undefined)
        ? returnedValue
        : this
        ;
    };

    $.fn.transition.exists = {};

    $.fn.transition.settings = {

        // module info
        name        : 'Transition',

        // debug content outputted to console
        debug       : false,

        // verbose debug output
        verbose     : true,

        // performance data output
        performance : true,

        // event namespace
        namespace   : 'transition',

        // animation complete event
        complete    : function() {},
        onShow      : function() {},
        onHide      : function() {},

        // whether animation can occur twice in a row
        allowRepeats : false,

        // animation duration
        animation  : 'fade',
        duration   : '700ms',

        // new animations will occur after previous ones
        queue       : true,

        className   : {
            animating  : 'animating',
            disabled   : 'disabled',
            hidden     : 'hidden',
            inward     : 'in',
            loading    : 'loading',
            looping    : 'looping',
            outward    : 'out',
            transition : 'ui transition',
            visible    : 'visible'
        },

        // possible errors
        error: {
            noAnimation : 'There is no css animation matching the one you specified.',
            repeated    : 'That animation is already occurring, cancelling repeated animation',
            method      : 'The method you called is not defined',
            support     : 'This browser does not support CSS animations'
        }

    };


})( jQuery, window , document );



/*
 * # Semantic - Accordion
 * http://github.com/jlukic/semantic-ui/
 *
 *
 * Copyright 2013 Contributors
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 */

;(function ($, window, document, undefined) {

    $.fn.accordion = function(parameters) {
        var
        $allModules     = $(this),

        time            = new Date().getTime(),
        performance     = [],

        query           = arguments[0],
        methodInvoked   = (typeof query == 'string'),
        queryArguments  = [].slice.call(arguments, 1),
        returnedValue
        ;
        $allModules
        .each(function() {
            var
            settings        = ( $.isPlainObject(parameters) )
            ? $.extend(true, {}, $.fn.accordion.settings, parameters)
            : $.extend({}, $.fn.accordion.settings),

            className       = settings.className,
            namespace       = settings.namespace,
            selector        = settings.selector,
            error           = settings.error,

            eventNamespace  = '.' + namespace,
            moduleNamespace = 'module-' + namespace,
            moduleSelector  = $allModules.selector || '',

            $module  = $(this),
            $title   = $module.find(selector.title),
            $content = $module.find(selector.content),

            element  = this,
            instance = $module.data(moduleNamespace),
            module
            ;

            module = {

                initialize: function() {
                    module.debug('Initializing accordion with bound events', $module);
                    // initializing
                    $title
                    .on('click' + eventNamespace, module.event.click)
                    ;
                    module.instantiate();
                },

                instantiate: function() {
                    instance = module;
                    $module
                    .data(moduleNamespace, module)
                    ;
                },

                destroy: function() {
                    module.debug('Destroying previous accordion for', $module);
                    $module
                    .removeData(moduleNamespace)
                    ;
                    $title
                    .off(eventNamespace)
                    ;
                },

                event: {
                    click: function() {
                        module.verbose('Title clicked', this);
                        var
                        $activeTitle = $(this),
                        index        = $title.index($activeTitle)
                        ;
                        module.toggle(index);
                    },
                    resetDisplay: function() {
                        $(this).css('display', '');
                        if( $(this).attr('style') == '') {
                            $(this)
                            .attr('style', '')
                            .removeAttr('style')
                            ;
                        }
                    },
                    resetOpacity: function() {
                        $(this).css('opacity', '');
                        if( $(this).attr('style') == '') {
                            $(this)
                            .attr('style', '')
                            .removeAttr('style')
                            ;
                        }
                    }
                },

                toggle: function(index) {
                    module.debug('Toggling content content at index', index);
                    var
                    $activeTitle   = $title.eq(index),
                    $activeContent = $activeTitle.next($content),
                    contentIsOpen  = $activeContent.is(':visible')
                    ;
                    if(contentIsOpen) {
                        if(settings.collapsible) {
                            module.close(index);
                        }
                        else {
                            module.debug('Cannot close accordion content collapsing is disabled');
                        }
                    }
                    else {
                        module.open(index);
                    }
                },

                open: function(index) {
                    var
                    $activeTitle     = $title.eq(index),
                    $activeContent   = $activeTitle.next($content),
                    $otherSections   = module.is.menu()
                    ? $activeTitle.parent().siblings(selector.item).find(selector.title)
                    : $activeTitle.siblings(selector.title),
                    $previousTitle   = $otherSections.filter('.' + className.active),
                    $previousContent = $previousTitle.next($title),
                    contentIsOpen    =  ($previousTitle.size() > 0)
                    ;
                    if( !$activeContent.is(':animated') ) {
                        module.debug('Opening accordion content', $activeTitle);
                        if(settings.exclusive && contentIsOpen) {
                            $previousTitle
                            .removeClass(className.active)
                            ;
                            $previousContent
                            .stop()
                            .children()
                            .stop()
                            .animate({
                                opacity: 0
                            }, settings.duration, module.event.resetOpacity)
                            .end()
                            .slideUp(settings.duration , settings.easing, function() {
                                $previousContent
                                .removeClass(className.active)
                                .children()
                                ;
                                $.proxy(module.event.resetDisplay, this)();
                            })
                            ;
                        }
                        $activeTitle
                        .addClass(className.active)
                        ;
                        $activeContent
                        .stop()
                        .children()
                        .stop()
                        .animate({
                            opacity: 1
                        }, settings.duration)
                        .end()
                        .slideDown(settings.duration, settings.easing, function() {
                            $activeContent
                            .addClass(className.active)
                            ;
                            $.proxy(module.event.resetDisplay, this)();
                            $.proxy(settings.onOpen, $activeContent)();
                            $.proxy(settings.onChange, $activeContent)();
                        })
                        ;
                    }
                },

                close: function(index) {
                    var
                    $activeTitle   = $title.eq(index),
                    $activeContent = $activeTitle.next($content)
                    ;
                    module.debug('Closing accordion content', $activeContent);
                    $activeTitle
                    .removeClass(className.active)
                    ;
                    $activeContent
                    .removeClass(className.active)
                    .show()
                    .stop()
                    .children()
                    .stop()
                    .animate({
                        opacity: 0
                    }, settings.duration, module.event.resetOpacity)
                    .end()
                    .slideUp(settings.duration, settings.easing, function(){
                        $.proxy(module.event.resetDisplay, this)();
                        $.proxy(settings.onClose, $activeContent)();
                        $.proxy(settings.onChange, $activeContent)();
                    })
                    ;
                },
                is: {
                    menu: function () {
                        return $module.hasClass(className.menu);
                    }
                },
                setting: function(name, value) {
                    if( $.isPlainObject(name) ) {
                        $.extend(true, settings, name);
                    }
                    else if(value !== undefined) {
                        settings[name] = value;
                    }
                    else {
                        return settings[name];
                    }
                },
                internal: function(name, value) {
                    module.debug('Changing internal', name, value);
                    if(value !== undefined) {
                        if( $.isPlainObject(name) ) {
                            $.extend(true, module, name);
                        }
                        else {
                            module[name] = value;
                        }
                    }
                    else {
                        return module[name];
                    }
                },
                debug: function() {
                    if(settings.debug) {
                        if(settings.performance) {
                            module.performance.log(arguments);
                        }
                        else {
                            module.debug = Function.prototype.bind.call(console.info, console, settings.name + ':');
                            module.debug.apply(console, arguments);
                        }
                    }
                },
                verbose: function() {
                    if(settings.verbose && settings.debug) {
                        if(settings.performance) {
                            module.performance.log(arguments);
                        }
                        else {
                            module.verbose = Function.prototype.bind.call(console.info, console, settings.name + ':');
                            module.verbose.apply(console, arguments);
                        }
                    }
                },
                error: function() {
                    module.error = Function.prototype.bind.call(console.error, console, settings.name + ':');
                    module.error.apply(console, arguments);
                },
                performance: {
                    log: function(message) {
                        var
                        currentTime,
                        executionTime,
                        previousTime
                        ;
                        if(settings.performance) {
                            currentTime   = new Date().getTime();
                            previousTime  = time || currentTime;
                            executionTime = currentTime - previousTime;
                            time          = currentTime;
                            performance.push({
                                'Element'        : element,
                                'Name'           : message[0],
                                'Arguments'      : [].slice.call(message, 1) || '',
                                'Execution Time' : executionTime
                            });
                        }
                        clearTimeout(module.performance.timer);
                        module.performance.timer = setTimeout(module.performance.display, 100);
                    },
                    display: function() {
                        var
                        title = settings.name + ':',
                        totalTime = 0
                        ;
                        time = false;
                        clearTimeout(module.performance.timer);
                        $.each(performance, function(index, data) {
                            totalTime += data['Execution Time'];
                        });
                        title += ' ' + totalTime + 'ms';
                        if(moduleSelector) {
                            title += ' \'' + moduleSelector + '\'';
                        }
                        if( (console.group !== undefined || console.table !== undefined) && performance.length > 0) {
                            console.groupCollapsed(title);
                            if(console.table) {
                                console.table(performance);
                            }
                            else {
                                $.each(performance, function(index, data) {
                                    console.log(data['Name'] + ': ' + data['Execution Time']+'ms');
                                });
                            }
                            console.groupEnd();
                        }
                        performance = [];
                    }
                },
                invoke: function(query, passedArguments, context) {
                    var
                    object = instance,
                    maxDepth,
                    found,
                    response
                    ;
                    passedArguments = passedArguments || queryArguments;
                    context         = element         || context;
                    if(typeof query == 'string' && object !== undefined) {
                        query    = query.split(/[\. ]/);
                        maxDepth = query.length - 1;
                        $.each(query, function(depth, value) {
                            var camelCaseValue = (depth != maxDepth)
                            ? value + query[depth + 1].charAt(0).toUpperCase() + query[depth + 1].slice(1)
                            : query
                            ;
                            if( $.isPlainObject( object[camelCaseValue] ) && (depth != maxDepth) ) {
                                object = object[camelCaseValue];
                            }
                            else if( object[camelCaseValue] !== undefined ) {
                                found = object[camelCaseValue];
                                return false;
                            }
                            else if( $.isPlainObject( object[value] ) && (depth != maxDepth) ) {
                                object = object[value];
                            }
                            else if( object[value] !== undefined ) {
                                found = object[value];
                                return false;
                            }
                            else {
                                return false;
                            }
                        });
                    }
                    if ( $.isFunction( found ) ) {
                        response = found.apply(context, passedArguments);
                    }
                    else if(found !== undefined) {
                        response = found;
                    }
                    if($.isArray(returnedValue)) {
                        returnedValue.push(response);
                    }
                    else if(returnedValue !== undefined) {
                        returnedValue = [returnedValue, response];
                    }
                    else if(response !== undefined) {
                        returnedValue = response;
                    }
                    return found;
                }
            };
            if(methodInvoked) {
                if(instance === undefined) {
                    module.initialize();
                }
                module.invoke(query);
            }
            else {
                if(instance !== undefined) {
                    module.destroy();
                }
                module.initialize();
            }
        })
        ;
        return (returnedValue !== undefined)
        ? returnedValue
        : this
        ;
    };

    $.fn.accordion.settings = {
        name        : 'Accordion',
        namespace   : 'accordion',

        debug       : false,
        verbose     : true,
        performance : true,

        exclusive   : true,
        collapsible : true,

        duration    : 500,
        easing      : 'easeInOutQuint',

        onOpen      : function(){},
        onClose     : function(){},
        onChange    : function(){},

        error: {
            method    : 'The method you called is not defined'
        },

        className   : {
            active : 'active',
            menu   : 'menu'
        },

        selector    : {
            title   : '.title',
            content : '.content',
            menu    : '.menu',
            item    : '.item'
        }


    };

    /*
     * # Semantic - Dropdown
     * http://github.com/jlukic/semantic-ui/
     *
     *
     * Copyright 2013 Contributors
     * Released under the MIT license
     * http://opensource.org/licenses/MIT
     *
     */
    ;(function ( $, window, document, undefined ) {

        $.fn.dropdown = function(parameters) {
            var
            $allModules    = $(this),
            $document      = $(document),

            moduleSelector = $allModules.selector || '',

            hasTouch       = ('ontouchstart' in document.documentElement),
            time           = new Date().getTime(),
            performance    = [],

            query          = arguments[0],
            methodInvoked  = (typeof query == 'string'),
            queryArguments = [].slice.call(arguments, 1),
            returnedValue
            ;

            $allModules
            .each(function() {
                var
                settings          = ( $.isPlainObject(parameters) )
                ? $.extend(true, {}, $.fn.dropdown.settings, parameters)
                : $.extend({}, $.fn.dropdown.settings),

                className       = settings.className,
                metadata        = settings.metadata,
                namespace       = settings.namespace,
                selector        = settings.selector,
                error           = settings.error,

                eventNamespace  = '.' + namespace,
                moduleNamespace = 'module-' + namespace,

                $module         = $(this),
                $item           = $module.find(selector.item),
                $text           = $module.find(selector.text),
                $input          = $module.find(selector.input),

                $menu           = $module.children(selector.menu),


                element         = this,
                instance        = $module.data(moduleNamespace),
                module
                ;

                module = {

                    initialize: function() {
                        module.debug('Initializing dropdown', settings);

                        module.save.defaults();
                        module.set.selected();

                        if(hasTouch) {
                            module.bind.touchEvents();
                        }
                        module.bind.mouseEvents();
                        module.bind.keyboardEvents();
                        module.instantiate();
                    },

                    instantiate: function() {
                        module.verbose('Storing instance of dropdown', module);
                        instance = module;
                        $module
                        .data(moduleNamespace, module)
                        ;
                    },

                    destroy: function() {
                        module.verbose('Destroying previous dropdown for', $module);
                        $item
                        .off(eventNamespace)
                        ;
                        $module
                        .off(eventNamespace)
                        .removeData(moduleNamespace)
                        ;
                    },

                    bind: {
                        keyboardEvents: function() {
                            module.debug('Binding keyboard events');
                            $module
                            .on('keydown' + eventNamespace, module.handleKeyboard)
                            ;
                            $module
                            .on('focus' + eventNamespace, module.show)
                            ;
                        },
                        touchEvents: function() {
                            module.debug('Touch device detected binding touch events');
                            $module
                            .on('touchstart' + eventNamespace, module.event.test.toggle)
                            ;
                            $item
                            .on('touchstart' + eventNamespace, module.event.item.mouseenter)
                            .on('touchstart' + eventNamespace, module.event.item.click)
                            ;
                        },
                        mouseEvents: function() {
                            module.verbose('Mouse detected binding mouse events');
                            if(settings.on == 'click') {
                                $module
                                .on('click' + eventNamespace, module.event.test.toggle)
                                ;
                            }
                            else if(settings.on == 'hover') {
                                $module
                                .on('mouseenter' + eventNamespace, module.delay.show)
                                .on('mouseleave' + eventNamespace, module.delay.hide)
                                ;
                            }
                            else {
                                $module
                                .on(settings.on + eventNamespace, module.toggle)
                                ;
                            }
                            $item
                            .on('mouseenter' + eventNamespace, module.event.item.mouseenter)
                            .on('mouseleave' + eventNamespace, module.event.item.mouseleave)
                            .on('click'      + eventNamespace, module.event.item.click)
                            ;
                        },
                        intent: function() {
                            module.verbose('Binding hide intent event to document');
                            if(hasTouch) {
                                $document
                                .on('touchstart' + eventNamespace, module.event.test.touch)
                                .on('touchmove'  + eventNamespace, module.event.test.touch)
                                ;
                            }
                            $document
                            .on('click' + eventNamespace, module.event.test.hide)
                            ;
                        }
                    },

                    unbind: {
                        intent: function() {
                            module.verbose('Removing hide intent event from document');
                            if(hasTouch) {
                                $document
                                .off('touchstart' + eventNamespace)
                                .off('touchmove' + eventNamespace)
                                ;
                            }
                            $document
                            .off('click' + eventNamespace)
                            ;
                        }
                    },

                    handleKeyboard: function(event) {
                        var
                        $selectedItem = $item.filter('.' + className.selected),
                        pressedKey    = event.which,
                        keys          = {
                            enter     : 13,
                            escape    : 27,
                            upArrow   : 38,
                            downArrow : 40
                        },
                        selectedClass   = className.selected,
                        currentIndex    = $item.index( $selectedItem ),
                        hasSelectedItem = ($selectedItem.size() > 0),
                        resultSize      = $item.size(),
                        newIndex
                        ;
                        // close shortcuts
                        if(pressedKey == keys.escape) {
                            module.verbose('Escape key pressed, closing dropdown');
                            module.hide();
                        }
                        // result shortcuts
                        if(module.is.visible()) {
                            if(pressedKey == keys.enter && hasSelectedItem) {
                                module.verbose('Enter key pressed, choosing selected item');
                                $.proxy(module.event.item.click, $item.filter('.' + selectedClass) )(event);
                                event.preventDefault();
                                return false;
                            }
                            else if(pressedKey == keys.upArrow) {
                                module.verbose('Up key pressed, changing active item');
                                newIndex = (currentIndex - 1 < 0)
                                ? currentIndex
                                : currentIndex - 1
                                ;
                                $item
                                .removeClass(selectedClass)
                                .eq(newIndex)
                                .addClass(selectedClass)
                                ;
                                event.preventDefault();
                            }
                            else if(pressedKey == keys.downArrow) {
                                module.verbose('Down key pressed, changing active item');
                                newIndex = (currentIndex + 1 >= resultSize)
                                ? currentIndex
                                : currentIndex + 1
                                ;
                                $item
                                .removeClass(selectedClass)
                                .eq(newIndex)
                                .addClass(selectedClass)
                                ;
                                event.preventDefault();
                            }
                        }
                        else {
                            if(pressedKey == keys.enter) {
                                module.show();
                            }
                        }
                    },

                    event: {
                        test: {
                            toggle: function(event) {
                                if( module.determine.intent(event, module.toggle) ) {
                                    event.preventDefault();
                                }
                            },
                            touch: function(event) {
                                module.determine.intent(event, function() {
                                    if(event.type == 'touchstart') {
                                        module.timer = setTimeout(module.hide, settings.delay.touch);
                                    }
                                    else if(event.type == 'touchmove') {
                                        clearTimeout(module.timer);
                                    }
                                });
                                event.stopPropagation();
                            },
                            hide: function(event) {
                                module.determine.intent(event, module.hide);
                            }
                        },

                        item: {

                            mouseenter: function(event) {
                                var
                                $currentMenu = $(this).find(selector.submenu),
                                $otherMenus  = $(this).siblings(selector.item).children(selector.menu)
                                ;
                                if($currentMenu.length > 0  || $otherMenus.length > 0) {
                                    clearTimeout(module.itemTimer);
                                    module.itemTimer = setTimeout(function() {
                                        if($otherMenus.length > 0) {
                                            module.animate.hide(false, $otherMenus.filter(':visible'));
                                        }
                                        if($currentMenu.length > 0) {
                                            module.verbose('Showing sub-menu', $currentMenu);
                                            module.animate.show(false, $currentMenu);
                                        }
                                    }, settings.delay.show * 2);
                                    event.preventDefault();
                                    event.stopPropagation();
                                }
                            },

                            mouseleave: function(event) {
                                var
                                $currentMenu = $(this).find(selector.menu)
                                ;
                                if($currentMenu.size() > 0) {
                                    clearTimeout(module.itemTimer);
                                    module.itemTimer = setTimeout(function() {
                                        module.verbose('Hiding sub-menu', $currentMenu);
                                        module.animate.hide(false,  $currentMenu);
                                    }, settings.delay.hide);
                                }
                            },

                            click: function (event) {
                                var
                                $choice = $(this),
                                text    = ( $choice.data(metadata.text) !== undefined )
                                ? $choice.data(metadata.text)
                                : $choice.text(),
                                value   = ( $choice.data(metadata.value) !== undefined)
                                ? $choice.data(metadata.value)
                                : (typeof text === 'string')
                                ? text.toLowerCase()
                                : text,
                                callback = function() {
                                    module.determine.selectAction(text, value);
                                    $.proxy(settings.onChange, element)(value, text);
                                }
                                ;
                                if( $choice.find(selector.menu).size() === 0 ) {
                                    if(event.type == 'touchstart') {
                                        $choice.one('click', callback);
                                    }
                                    else {
                                        callback();
                                    }
                                }
                            }

                        },

                        resetStyle: function() {
                            $(this).removeAttr('style');
                        }

                    },

                    determine: {
                        selectAction: function(text, value) {
                            module.verbose('Determining action', settings.action);
                            if( $.isFunction( module.action[settings.action] ) ) {
                                module.verbose('Triggering preset action', settings.action, text, value);
                                module.action[ settings.action ](text, value);
                            }
                            else if( $.isFunction(settings.action) ) {
                                module.verbose('Triggering user action', settings.action, text, value);
                                settings.action(text, value);
                            }
                            else {
                                module.error(error.action, settings.action);
                            }
                        },
                        intent: function(event, callback) {
                            module.debug('Determining whether event occurred in dropdown', event.target);
                            callback = callback || function(){};
                            if( $(event.target).closest($menu).size() === 0 ) {
                                module.verbose('Triggering event', callback);
                                callback();
                                return true;
                            }
                            else {
                                module.verbose('Event occurred in dropdown, canceling callback');
                                return false;
                            }
                        }
                    },

                    action: {

                        nothing: function() {},

                        hide: function() {
                            module.hide();
                        },

                        activate: function(text, value) {
                            value = (value !== undefined)
                            ? value
                            : text
                            ;
                            module.set.selected(value);
                            module.set.value(value);
                            module.hide();
                        },

                        /* Deprecated */
                        auto: function(text, value) {
                            value = (value !== undefined)
                            ? value
                            : text
                            ;
                            module.set.selected(value);
                            module.set.value(value);
                            module.hide();
                        },

                        /* Deprecated */
                        changeText: function(text, value) {
                            value = (value !== undefined)
                            ? value
                            : text
                            ;
                            module.set.selected(value);
                            module.hide();
                        },

                        /* Deprecated */
                        updateForm: function(text, value) {
                            value = (value !== undefined)
                            ? value
                            : text
                            ;
                            module.set.selected(value);
                            module.set.value(value);
                            module.hide();
                        }

                    },

                    get: {
                        text: function() {
                            return $text.text();
                        },
                        value: function() {
                            return ($input.size() > 0)
                            ? $input.val()
                            : $module.data(metadata.value)
                            ;
                        },
                        item: function(value, strict) {
                            var
                            $selectedItem = false
                            ;
                            value = (value !== undefined)
                            ? value
                            : ( module.get.value() !== undefined)
                            ? module.get.value()
                            : module.get.text()
                            ;
                            if(strict === undefined && value === '') {
                                module.debug('Ambiguous dropdown value using strict type check', value);
                                strict = true;
                            }
                            else {
                                strict = strict || false;
                            }
                            if(value !== undefined) {
                                $item
                                .each(function() {
                                    var
                                    $choice       = $(this),
                                    optionText    = ( $choice.data(metadata.text) !== undefined )
                                    ? $choice.data(metadata.text)
                                    : $choice.text(),
                                    optionValue   = ( $choice.data(metadata.value) !== undefined )
                                    ? $choice.data(metadata.value)
                                    : (typeof optionText === 'string')
                                    ? optionText.toLowerCase()
                                    : optionText
                                    ;
                                    if(strict) {
                                        if( optionValue === value ) {
                                            $selectedItem = $(this);
                                        }
                                        else if( !$selectedItem && optionText === value ) {
                                            $selectedItem = $(this);
                                        }
                                    }
                                    else {
                                        if( optionValue == value ) {
                                            $selectedItem = $(this);
                                        }
                                        else if( !$selectedItem && optionText == value ) {
                                            $selectedItem = $(this);
                                        }
                                    }
                                })
                                ;
                            }
                            else {
                                value = module.get.text();
                            }
                            return $selectedItem || false;
                        }
                    },

                    restore: {
                        defaults: function() {
                            module.restore.defaultText();
                            module.restore.defaultValue();
                        },
                        defaultText: function() {
                            var
                            defaultText = $module.data(metadata.defaultText)
                            ;
                            module.debug('Restoring default text', defaultText);
                            module.set.text(defaultText);
                        },
                        defaultValue: function() {
                            var
                            defaultValue = $module.data(metadata.defaultValue)
                            ;
                            if(defaultValue !== undefined) {
                                module.debug('Restoring default value', defaultValue);
                                module.set.selected(defaultValue);
                                module.set.value(defaultValue);
                            }
                        }
                    },

                    save: {
                        defaults: function() {
                            module.save.defaultText();
                            module.save.defaultValue();
                        },
                        defaultValue: function() {
                            $module.data(metadata.defaultValue, module.get.value() );
                        },
                        defaultText: function() {
                            $module.data(metadata.defaultText, $text.text() );
                        }
                    },

                    set: {
                        text: function(text) {
                            module.debug('Changing text', text, $text);
                            $text.removeClass(className.placeholder);
                            $text.text(text);
                        },
                        value: function(value) {
                            module.debug('Adding selected value to hidden input', value, $input);
                            if($input.size() > 0) {
                                $input
                                .val(value)
                                .trigger('change')
                                ;
                            }
                            else {
                                $module.data(metadata.value, value);
                            }
                        },
                        active: function() {
                            $module.addClass(className.active);
                        },
                        visible: function() {
                            $module.addClass(className.visible);
                        },
                        selected: function(value) {
                            var
                            $selectedItem = module.get.item(value),
                            selectedText
                            ;
                            if($selectedItem) {
                                module.debug('Setting selected menu item to', $selectedItem);
                                selectedText = ($selectedItem.data(metadata.text) !== undefined)
                                ? $selectedItem.data(metadata.text)
                                : $selectedItem.text()
                                ;
                                $item
                                .removeClass(className.active)
                                ;
                                $selectedItem
                                .addClass(className.active)
                                ;
                                module.set.text(selectedText);
                            }
                        }
                    },

                    remove: {
                        active: function() {
                            $module.removeClass(className.active);
                        },
                        visible: function() {
                            $module.removeClass(className.visible);
                        }
                    },

                    is: {
                        selection: function() {
                            return $module.hasClass(className.selection);
                        },
                        animated: function($subMenu) {
                            return ($subMenu)
                            ? $subMenu.is(':animated') || $subMenu.transition && $subMenu.transition('is animating')
                            : $menu.is(':animated') || $menu.transition && $menu.transition('is animating')
                            ;
                        },
                        visible: function($subMenu) {
                            return ($subMenu)
                            ? $subMenu.is(':visible')
                            : $menu.is(':visible')
                            ;
                        },
                        hidden: function($subMenu) {
                            return ($subMenu)
                            ? $subMenu.is(':not(:visible)')
                            : $menu.is(':not(:visible)')
                            ;
                        }
                    },

                    can: {
                        click: function() {
                            return (hasTouch || settings.on == 'click');
                        },
                        show: function() {
                            return !$module.hasClass(className.disabled);
                        }
                    },

                    animate: {
                        show: function(callback, $subMenu) {
                            var
                            $currentMenu = $subMenu || $menu
                            ;
                            callback = callback || function(){};
                            if( module.is.hidden($currentMenu) ) {
                                module.verbose('Doing menu show animation', $currentMenu);
                                if(settings.transition == 'none') {
                                    callback();
                                }
                                else if($.fn.transition !== undefined && $module.transition('is supported')) {
                                    $currentMenu
                                    .transition({
                                        animation : settings.transition + ' in',
                                        duration  : settings.duration,
                                        complete  : callback,
                                        queue     : false
                                    })
                                    ;
                                }
                                else if(settings.transition == 'slide down') {
                                    $currentMenu
                                    .hide()
                                    .clearQueue()
                                    .children()
                                    .clearQueue()
                                    .css('opacity', 0)
                                    .delay(50)
                                    .animate({
                                        opacity : 1
                                    }, settings.duration, 'easeOutQuad', module.event.resetStyle)
                                    .end()
                                    .slideDown(100, 'easeOutQuad', function() {
                                        $.proxy(module.event.resetStyle, this)();
                                        callback();
                                    })
                                    ;
                                }
                                else if(settings.transition == 'fade') {
                                    $currentMenu
                                    .hide()
                                    .clearQueue()
                                    .fadeIn(settings.duration, function() {
                                        $.proxy(module.event.resetStyle, this)();
                                        callback();
                                    })
                                    ;
                                }
                                else {
                                    module.error(error.transition, settings.transition);
                                }
                            }
                        },
                        hide: function(callback, $subMenu) {
                            var
                            $currentMenu = $subMenu || $menu
                            ;
                            callback = callback || function(){};
                            if(module.is.visible($currentMenu) ) {
                                module.verbose('Doing menu hide animation', $currentMenu);
                                if($.fn.transition !== undefined && $module.transition('is supported')) {
                                    $currentMenu
                                    .transition({
                                        animation : settings.transition + ' out',
                                        duration  : settings.duration,
                                        complete  : callback,
                                        queue     : false
                                    })
                                    ;
                                }
                                else if(settings.transition == 'none') {
                                    callback();
                                }
                                else if(settings.transition == 'slide down') {
                                    $currentMenu
                                    .show()
                                    .clearQueue()
                                    .children()
                                    .clearQueue()
                                    .css('opacity', 1)
                                    .animate({
                                        opacity : 0
                                    }, 100, 'easeOutQuad', module.event.resetStyle)
                                    .end()
                                    .delay(50)
                                    .slideUp(100, 'easeOutQuad', function() {
                                        $.proxy(module.event.resetStyle, this)();
                                        callback();
                                    })
                                    ;
                                }
                                else if(settings.transition == 'fade') {
                                    $currentMenu
                                    .show()
                                    .clearQueue()
                                    .fadeOut(150, function() {
                                        $.proxy(module.event.resetStyle, this)();
                                        callback();
                                    })
                                    ;
                                }
                                else {
                                    module.error(error.transition);
                                }
                            }
                        }
                    },

                    show: function() {
                        module.debug('Checking if dropdown can show');
                        if( module.is.hidden() ) {
                            module.hideOthers();
                            module.set.active();
                            module.animate.show(function() {
                                if( module.can.click() ) {
                                    module.bind.intent();
                                }
                                module.set.visible();
                            });
                            $.proxy(settings.onShow, element)();
                        }
                    },

                    hide: function() {
                        if( !module.is.animated() && module.is.visible() ) {
                            module.debug('Hiding dropdown');
                            if( module.can.click() ) {
                                module.unbind.intent();
                            }
                            module.remove.active();
                            module.animate.hide(module.remove.visible);
                            $.proxy(settings.onHide, element)();
                        }
                    },

                    delay: {
                        show: function() {
                            module.verbose('Delaying show event to ensure user intent');
                            clearTimeout(module.timer);
                            module.timer = setTimeout(module.show, settings.delay.show);
                        },
                        hide: function() {
                            module.verbose('Delaying hide event to ensure user intent');
                            clearTimeout(module.timer);
                            module.timer = setTimeout(module.hide, settings.delay.hide);
                        }
                    },

                    hideOthers: function() {
                        module.verbose('Finding other dropdowns to hide');
                        $allModules
                        .not($module)
                        .has(selector.menu + ':visible')
                        .dropdown('hide')
                        ;
                    },

                    toggle: function() {
                        module.verbose('Toggling menu visibility');
                        if( module.is.hidden() ) {
                            module.show();
                        }
                        else {
                            module.hide();
                        }
                    },

                    setting: function(name, value) {
                        if( $.isPlainObject(name) ) {
                            $.extend(true, settings, name);
                        }
                        else if(value !== undefined) {
                            settings[name] = value;
                        }
                        else {
                            return settings[name];
                        }
                    },
                    internal: function(name, value) {
                        if( $.isPlainObject(name) ) {
                            $.extend(true, module, name);
                        }
                        else if(value !== undefined) {
                            module[name] = value;
                        }
                        else {
                            return module[name];
                        }
                    },
                    debug: function() {
                        if(settings.debug) {
                            if(settings.performance) {
                                module.performance.log(arguments);
                            }
                            else {
                                module.debug = Function.prototype.bind.call(console.info, console, settings.name + ':');
                                module.debug.apply(console, arguments);
                            }
                        }
                    },
                    verbose: function() {
                        if(settings.verbose && settings.debug) {
                            if(settings.performance) {
                                module.performance.log(arguments);
                            }
                            else {
                                module.verbose = Function.prototype.bind.call(console.info, console, settings.name + ':');
                                module.verbose.apply(console, arguments);
                            }
                        }
                    },
                    error: function() {
                        module.error = Function.prototype.bind.call(console.error, console, settings.name + ':');
                        module.error.apply(console, arguments);
                    },
                    performance: {
                        log: function(message) {
                            var
                            currentTime,
                            executionTime,
                            previousTime
                            ;
                            if(settings.performance) {
                                currentTime   = new Date().getTime();
                                previousTime  = time || currentTime;
                                executionTime = currentTime - previousTime;
                                time          = currentTime;
                                performance.push({
                                    'Element'        : element,
                                    'Name'           : message[0],
                                    'Arguments'      : [].slice.call(message, 1) || '',
                                    'Execution Time' : executionTime
                                });
                            }
                            clearTimeout(module.performance.timer);
                            module.performance.timer = setTimeout(module.performance.display, 100);
                        },
                        display: function() {
                            var
                            title = settings.name + ':',
                            totalTime = 0
                            ;
                            time = false;
                            clearTimeout(module.performance.timer);
                            $.each(performance, function(index, data) {
                                totalTime += data['Execution Time'];
                            });
                            title += ' ' + totalTime + 'ms';
                            if(moduleSelector) {
                                title += ' \'' + moduleSelector + '\'';
                            }
                            if( (console.group !== undefined || console.table !== undefined) && performance.length > 0) {
                                console.groupCollapsed(title);
                                if(console.table) {
                                    console.table(performance);
                                }
                                else {
                                    $.each(performance, function(index, data) {
                                        console.log(data['Name'] + ': ' + data['Execution Time']+'ms');
                                    });
                                }
                                console.groupEnd();
                            }
                            performance = [];
                        }
                    },
                    invoke: function(query, passedArguments, context) {
                        var
                        object = instance,
                        maxDepth,
                        found,
                        response
                        ;
                        passedArguments = passedArguments || queryArguments;
                        context         = element         || context;
                        if(typeof query == 'string' && object !== undefined) {
                            query    = query.split(/[\. ]/);
                            maxDepth = query.length - 1;
                            $.each(query, function(depth, value) {
                                var camelCaseValue = (depth != maxDepth)
                                ? value + query[depth + 1].charAt(0).toUpperCase() + query[depth + 1].slice(1)
                                : query
                                ;
                                if( $.isPlainObject( object[camelCaseValue] ) && (depth != maxDepth) ) {
                                    object = object[camelCaseValue];
                                }
                                else if( object[camelCaseValue] !== undefined ) {
                                    found = object[camelCaseValue];
                                    return false;
                                }
                                else if( $.isPlainObject( object[value] ) && (depth != maxDepth) ) {
                                    object = object[value];
                                }
                                else if( object[value] !== undefined ) {
                                    found = object[value];
                                    return false;
                                }
                                else {
                                    module.error(error.method, query);
                                    return false;
                                }
                            });
                        }
                        if ( $.isFunction( found ) ) {
                            response = found.apply(context, passedArguments);
                        }
                        else if(found !== undefined) {
                            response = found;
                        }
                        if($.isArray(returnedValue)) {
                            returnedValue.push(response);
                        }
                        else if(returnedValue !== undefined) {
                            returnedValue = [returnedValue, response];
                        }
                        else if(response !== undefined) {
                            returnedValue = response;
                        }
                        return found;
                    }
                };

                if(methodInvoked) {
                    if(instance === undefined) {
                        module.initialize();
                    }
                    module.invoke(query);
                }
                else {
                    if(instance !== undefined) {
                        module.destroy();
                    }
                    module.initialize();
                }
            })
            ;

            return (returnedValue !== undefined)
            ? returnedValue
            : this
            ;
        };

        $.fn.dropdown.settings = {

            name        : 'Dropdown',
            namespace   : 'dropdown',

            debug       : false,
            verbose     : true,
            performance : true,

            on          : 'click',
            action      : 'activate',

            delay: {
                show  : 200,
                hide  : 300,
                touch : 50
            },

            transition : 'slide down',
            duration   : 250,

            onChange : function(value, text){},
            onShow   : function(){},
            onHide   : function(){},

            error   : {
                action    : 'You called a dropdown action that was not defined',
                method    : 'The method you called is not defined.',
                transition : 'The requested transition was not found'
            },

            metadata: {
                defaultText  : 'defaultText',
                defaultValue : 'defaultValue',
                text         : 'text',
                value        : 'value'
            },

            selector : {
                menu    : '.menu',
                submenu : '> .menu',
                item    : '.menu > .item',
                text    : '> .text',
                input   : '> input[type="hidden"]'
            },

            className : {
                active      : 'active',
                placeholder : 'default',
                disabled    : 'disabled',
                visible     : 'visible',
                selected    : 'selected',
                selection   : 'selection'
            }

        };

        // Adds easing
        $.extend( $.easing, {
            easeOutQuad: function (x, t, b, c, d) {
                return -c *(t/=d)*(t-2) + b;
            }
        });


    })( jQuery, window , document );

    // Adds easing
    $.extend( $.easing, {
        easeInOutQuint: function (x, t, b, c, d) {
            if ((t/=d/2) < 1) return c/2*t*t*t*t*t + b;
            return c/2*((t-=2)*t*t*t*t + 2) + b;
        }
    });

})( jQuery, window , document );
